/*!
  * @hy-hybrid/kiwi-js-sdk 0.1.99 
  * Copyright 2017-2022 huya. All Rights Reserved
  */
 
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var classCallCheck = _classCallCheck;

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var createClass = _createClass;

var getBridge = function getBridge() {
  try {
    if (window.top && window.self != window.top && window.top.KiwiJSBridge) {
      return window.top.KiwiJSBridge;
    } else {
      return window.KiwiJSBridge;
    }
  } catch (e) {
    return window.KiwiJSBridge;
  }
};

/** 
 * @author: Haisheng Ding  
 * @date: 2020-03-18 11:57:30  
 * @last modified by:   Haisheng Ding 
 * @last modified time: 2020-03-18 11:57:30 
 */

/**
* 浏览器类型
* @namespace Browser
*/
var Browser = {
  /**
   * @memberof Browser
   * @property {object}
   */
  versions: function () {
    var u = navigator.userAgent;
    return {
      trident: u.indexOf('Trident') > -1,
      //IE内核 presto: u.indexOf('Presto') > -1, //opera内核 
      webKit: u.indexOf('AppleWebKit') > -1,
      //苹果、谷歌内核 
      gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,
      //火狐内核 
      mobile: !!u.match(/AppleWebKit.*Mobile.*/),
      //是否为移动终端 
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
      //ios终端 
      android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1,
      //android终端 
      iPhone: u.indexOf('iPhone') > -1,
      //是否为iPhone或者QQHD浏览器 
      iPad: u.indexOf('iPad') > -1,
      //是否iPad 
      webApp: u.indexOf('Safari') == -1,
      //是否web应该程序，没有头部与底部 
      weixin: u.indexOf('MicroMessenger') > -1,
      //是否微信 （2015-01-22新增） 
      qq: u.match(/\sQQ/i) == ' qq' //是否QQ 

    };
  }(),
  language: (navigator.browserLanguage || navigator.language).toLowerCase()
};

var MessageQueue = /*#__PURE__*/function () {
  function MessageQueue() {
    classCallCheck(this, MessageQueue);

    this._messageQueue = [];
  }

  createClass(MessageQueue, [{
    key: "messageQueue",
    value: function messageQueue() {
      return this._messageQueue;
    }
  }, {
    key: "clear",
    value: function clear() {
      this._messageQueue = [];
    }
  }, {
    key: "pushCallMsg",
    value: function pushCallMsg(moduleName, func, options, params) {
      this._messageQueue.push({
        type: 'call',
        module: moduleName,
        func: func,
        options: options,
        params: params
      });
    }
  }, {
    key: "pushOnMsg",
    value: function pushOnMsg(moduleName, eventId, params, callback) {
      this._messageQueue.push({
        type: 'on',
        module: moduleName,
        eventId: eventId,
        params: params,
        callback: callback
      });
    }
  }, {
    key: "pushOffMsg",
    value: function pushOffMsg(moduleName, eventId, params, callback) {
      this._messageQueue.push({
        type: 'off',
        module: moduleName,
        eventId: eventId,
        params: params,
        callback: callback
      });
    }
  }]);

  return MessageQueue;
}();

var NativeBridge = /*#__PURE__*/function () {
  function NativeBridge() {
    classCallCheck(this, NativeBridge);

    this._messageQueue = new MessageQueue();
  } //兼容老的调用方式


  createClass(NativeBridge, [{
    key: "invoke",
    value: function invoke(func, options, params) {
      //允许前端选择是否使用postMessage
      options.usePostMessageByDefault = true;
      options.useProcolByDefault = false;
      options.useContextByDefault = false;

      if (getBridge()) {
        getBridge().call(func, options, function (resp) {
          this.handleResponse(func, resp, params);
        }.bind(this));
      } else {
        this._messageQueue.pushCallMsg(undefined, func, options, params);
      }
    }
  }, {
    key: "on",
    value: function on(eventId, params, callback) {
      if (getBridge()) {
        getBridge().on(eventId, params, callback);
      } else {
        this._messageQueue.pushOnMsg(undefined, eventId, params, callback);
      }
    }
  }, {
    key: "off",
    value: function off(eventId, params, callback) {
      if (getBridge()) {
        getBridge().off(eventId, params, callback);
      } else {
        this._messageQueue.pushOffMsg(undefined, eventId, params, callback);
      }
    }
    /**
     *新的调用方式，业务直接通过ModuleName.methodName(params).then((data)=>{}).cacth(err=>{})方式调用;
     *
     * @param {*} module
     * @param {*} func
     * @param {*} params
     * @param {*} callback
     * @memberof NativeBridge
     */

  }, {
    key: "invokeWithModule",
    value: function invokeWithModule(moduleName, methodName, params, callback) {
      if (getBridge()) {
        getBridge().callWithModule(moduleName, methodName, params, callback);
      } else {
        this._messageQueue.pushCallMsg(moduleName, methodName, params, {
          callback: callback
        });
      }
    }
  }, {
    key: "onWithModule",
    value: function onWithModule(moduleName, eventId, params, callback) {
      if (getBridge()) {
        getBridge().onWithModule(moduleName, eventId, params, callback);
      } else {
        this._messageQueue.pushOnMsg(moduleName, eventId, params, callback);
      }
    }
  }, {
    key: "offWithModule",
    value: function offWithModule(moduleName, eventId, params, callback) {
      if (getBridge()) {
        getBridge().offWithModule(moduleName, eventId, params, callback);
      } else {
        this._messageQueue.pushOffMsg(moduleName, eventId, params, callback);
      }
    }
  }, {
    key: "handleQueuedMessage",
    value: function handleQueuedMessage() {
      var _this = this;

      var messageQueue = this._messageQueue.messageQueue();

      messageQueue.forEach(function (msg) {
        if (msg.type === 'call') {
          if (msg.module) {
            getBridge().callWithModule(msg.module, msg.func, msg.options, msg.params.callback);
          } else {
            getBridge().call(msg.func, msg.options, function (resp) {
              this.handleResponse(msg.func, resp, msg.params);
            }.bind(_this));
          }
        } else if (msg.type === 'on') {
          if (msg.module) {
            getBridge().onWithModule(msg.module, msg.eventId, msg.params, msg.callback);
          } else {
            getBridge().on(msg.eventId, msg.params, msg.callback);
          }
        } else if (msg.type === 'off') {
          if (msg.module) {
            getBridge().offWithModule(msg.moduleName, msg.eventId, msg.params, msg.callback);
          } else {
            getBridge().off(msg.eventId, msg.params, msg.callback);
          }
        }
      });

      this._messageQueue.clear();
    }
  }, {
    key: "handleResponse",
    value: function handleResponse(func, resp, params) {
      if (!params) {
        //如果没有传入参数则丢掉，防止js报错
        return;
      }
      /*
       安卓是用loadUrl执行js,loadUrl：javascript:xxx会对参数先做一次unescape
       会导致native想传 %2F 结果到了js变为了 /,导致udbtoken验证失败
       */


      if (Browser.versions.android && (!getBridge() || !getBridge().isNewBridge)) {
        //暂时只针对udbToken作差异逻辑
        if (resp.udbToken && resp.udbToken.length) {
          resp.udbToken = encodeURIComponent(resp.udbToken);
        }
      }

      switch (resp.status) {
        case 'ok':
          if (params.success) {
            params.success(resp);
          }

          break;

        case 'cancel':
          if (params.cancel) {
            params.cancel(resp);
          }

          break;

        default:
          if (params.fail) {
            params.fail(resp);
          }

      }

      if (params.complete) {
        params.complete(resp);
      }
    }
  }]);

  return NativeBridge;
}();

var nativeBridge = new NativeBridge();

/** 
 * @author: Haisheng Ding  
 * @date: 2020-03-18 18:05:34  
 * @last modified by:   Haisheng Ding 
 * @last modified time: 2020-03-18 18:05:34 
 */
var _DOM_READY_IFRAME_ID = '__HUYAJSBridgeIframe_DomReady';

function _createDomReadyIFrame() {
  var domReady = document.createElement('iframe');
  domReady.id = _DOM_READY_IFRAME_ID;
  domReady.style.display = 'none';
  document.documentElement.appendChild(domReady);
  domReady.src = 'kiwi://DOMContentLoaded';
}

function _removeDomReadyIFrame() {
  var elem = document.getElementById(_DOM_READY_IFRAME_ID);

  if (elem) {
    document.documentElement.removeChild(elem);
  }
}

function _readyEventListenerHandle() {
  nativeBridge.handleQueuedMessage();
  getBridge().call('ready', {
    usePostMessageByDefault: true
  }, function () {}); //准备好后负责domReady的iframe就没用了

  setTimeout(function () {
    _removeDomReadyIFrame();
  }, 1000);
}

function addReadyEventListener(handle) {
  if (getBridge()) {
    handle();
  } else {
    if (document.addEventListener) {
      document.addEventListener('KiwiWebViewJavascriptBridgeReady', handle, false);
    }
  }
}

function _setupOnError() {
  window.onerror = function (sMsg, sUrl, sLine) {
    sMsg = sMsg ? sMsg : '';
    sUrl = sUrl ? sUrl : '';
    sLine = sLine ? sLine : '';
    var errorInfo = 'error:' + sMsg + '\n';
    errorInfo += 'URL:' + sUrl + '\n';
    errorInfo += 'Line:' + sLine + '\n';

    if (window.fnError) {
      window.fnError(sMsg, sUrl, sLine);
    }

    getBridge().call('onerror', {
      errorInfo: errorInfo,
      usePostMessageByDefault: true
    }, function () {});
    return false;
  };
}

function setup() {
  addReadyEventListener(_readyEventListenerHandle);

  if (document.readyState == 'interactive' || document.readyState == 'complete') {
    try {
      _createDomReadyIFrame(); // eslint-disable-next-line no-empty

    } catch (e) {}
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      _createDomReadyIFrame();
    });
  } //安卓的话通过这种方式注入


  if (Browser.versions.android) {
    var head = document.getElementsByTagName('head')[0];
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'KWBridge://huya.com/load_KwBridge.js';
    head.appendChild(script);
  }

  _setupOnError();
}

var NativeModules = /*#__PURE__*/function () {
  function NativeModules() {
    classCallCheck(this, NativeModules);

    if (this.getWindow().__HYAndroidMessageHandlers) {
      var moduleInfos = this.getWindow().__HYAndroidMessageHandlers.getModuleInfo();

      this.setupModules(JSON.parse(moduleInfos));
    } else if (this.getWindow().__hyNativeModuleInfo__) {
      this.setupModules(this.getWindow().__hyNativeModuleInfo__);
    }
  }

  createClass(NativeModules, [{
    key: "getWindow",
    value: function getWindow() {
      try {
        if (window.top && window.self != window.top && window.top.document) {
          return window.top;
        }

        return window;
      } catch (e) {
        return window;
      }
    }
    /**
     * 初始化module
     *
     * @param {*} moduleInfo，[{name:ModuleA,constants:{key1:value1,key2:value2},methods:[method1,method2],isEmitter:false}]
     * @memberof NativeModules
     */

  }, {
    key: "setupModules",
    value: function setupModules(moduleInfo) {
      var _this = this;

      moduleInfo.forEach(function (item) {
        var moduleObj = {};
        var moduleName = item['name'];

        if (item.constants) {
          Object.getOwnPropertyNames(item.constants).forEach(function (key) {
            Object.defineProperty(moduleObj, key, {
              enumerable: false,
              configurable: false,
              writable: false,
              value: item.constants[key]
            });
          });
        }

        if (item.methods) {
          item.methods.forEach(function (methodName) {
            var fun = function fun(params) {
              return new Promise(function (resolve, reject) {
                nativeBridge.invokeWithModule(moduleName, methodName, params, function (resp) {
                  if (resp.errorCode === 0) {
                    /*兼容老逻辑，安卓是用loadUrl执行js,loadUrl：javascript:xxx会对参数先做一次unescape
                    会导致native想传 %2F 结果到了js变为了 /,导致udbtoken验证失败
                    */
                    if (Browser.versions.android && (!getBridge() || !getBridge().isNewBridge)) {
                      //暂时只针对udbToken作差异逻辑
                      if (resp.data.udbToken && resp.data.udbToken.length) {
                        resp.data.udbToken = encodeURIComponent(resp.data.udbToken);
                      }
                    }

                    resolve(resp.data);
                  } else {
                    reject({
                      errorCode: resp.errorCode,
                      message: resp.data
                    });
                  }
                });
              });
            };

            Object.defineProperty(moduleObj, methodName, {
              enumerable: false,
              configurable: false,
              writable: false,
              value: fun
            });
          });
        }

        if (item.isEmitter) {
          var on = function on(eventId, callback, params) {
            nativeBridge.onWithModule(moduleName, eventId, params, callback);
          };

          var off = function off(eventId, callback, params) {
            nativeBridge.offWithModule(moduleName, eventId, params, callback);
          };

          Object.defineProperty(moduleObj, 'on', {
            enumerable: false,
            configurable: false,
            writable: false,
            value: on
          });
          Object.defineProperty(moduleObj, 'off', {
            enumerable: false,
            configurable: false,
            writable: false,
            value: off
          });
        }

        if (_this.hasOwnProperty(moduleName)) {
          console.error("Can not redefine " + moduleName);
        } else {
          Object.defineProperty(_this, moduleName, {
            enumerable: false,
            configurable: false,
            writable: false,
            value: moduleObj
          });
        }
      });
    }
  }]);

  return NativeModules;
}();

var nativeModules = new NativeModules();
window.__hySetupNativeModules__ = nativeModules.setupModules.bind(nativeModules);

/**
 * HUYASdk工具对象
 * @namespace Utils
 */

/**
 * 将base64字符串转为对应的blob对象
 * @function base64ToBlob
 * @memberof Utils
 * @param {string} base64 - base64编码的字符串
 * @returns {blob}  对应的blob对象
 */
function _base64ToBlob(base64) {
  var buffer = _base64ToArrayBuffer(base64);

  return new Blob([buffer]);
}
/**
 * 将base64字符串转为对应的arrayBuffer对象
 * @function base64ToArrayBuffer
 * @memberof Utils
 * @param {string} base64 - base64编码的字符串
 * @returns {arrayBuffer} 二进制utf8的arraybuffer
 */


function _base64ToArrayBuffer(base64) {
  var binary_string = window.atob(base64);
  var len = binary_string.length;
  var bytes = new Uint8Array(len);

  for (var i = 0; i < len; i++) {
    bytes[i] = binary_string.charCodeAt(i);
  }

  return bytes.buffer;
}
/**
 * 将ArrayBuffer转为对应的base64字符串
 * @function arrayBufferToBase64
 * @memberof Utils
 * @param {arrayBuffer} buffer - 二进制buffer对象
 * @returns {string}  base64编码的字符串
 */


function _arrayBufferToBase64(buffer) {
  var binary = '';
  var bytes = new Uint8Array(buffer);
  var len = bytes.byteLength;

  for (var i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }

  return window.btoa(binary);
}
/**
 * 从url的query中解析出对应参数名的值
 * @function getParameterByName
 * @memberof Utils
 * @param {string} name - 参数名
 * @param {string} url  - url字符串
 * @returns {string}  对应参数名的参数值
 */


function _getParameterByName(name, url) {
  if (!url) url = window.location.href; // eslint-disable-next-line no-useless-escape

  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
/**
 * 将source对象的属性作一次浅拷贝到dest对象
 * @function shallowExtend
 * @memberof Utils
 * @param {object} dest - 目标对象
 * @param {object} source  - 源对象
 */


function _shallowExtend(dest, source) {
  for (var property in source) {
    if (source.hasOwnProperty(property)) {
      dest[property] = source[property];
    }
  }
}
/**
 * 对比两个版本号的大小
 * @function compareVersion
 * @memberof Utils
 * @param {array} version1 - 版本号1，用.分割的三位版本号 (eg: 5.10.0）
 * @param {array} version2 - 版本号2，用.分割的三位版本号 (eg: 5.10.0)
 * @returns {number}  1: version1 > version2; 0: version1 == version2; -1: version1 < version2
 */


function _versionCompare(version1, version2) {
  version1 = version1 || '0.0.0';
  version2 = version2 || '0.0.0';
  if (version1 == version2) return 0;
  var verArr1 = version1.split('.');
  var verArr2 = version2.split('.');
  var len = Math.max(verArr1.length, verArr2.length);

  for (var i = 0; i < len; i++) {
    var ver1 = parseInt(verArr1[i]);
    var ver2 = parseInt(verArr2[i]);

    if (ver1 > ver2) {
      return 1;
    } else if (ver1 < ver2) {
      return -1;
    }
  }

  return 0;
}
/**
 * @memberof HUYASdk
 * @property {Utils}
 */


var Utils = {
  arrayBufferToBase64: _arrayBufferToBase64,
  base64ToArrayBuffer: _base64ToArrayBuffer,
  base64ToBlob: _base64ToBlob,
  getParameterByName: _getParameterByName,
  shallowExtend: _shallowExtend,
  versionCompare: _versionCompare,
  appendQueryString: function appendQueryString(url, obj) {
    url = url ? url : '';

    for (var key in obj) {
      if (obj[key]) {
        url += '&' + key + '=' + obj[key];
      }
    }

    return url;
  }
};

/** 
 * @author: Haisheng Ding  
 * @date: 2020-03-17 16:45:10  
 * @last modified by:   Haisheng Ding 
 * @last modified time: 2020-03-17 16:45:10 
 */
var HYLog = {
  debug: function debug() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYLog && nativeModules.HYLog.debug) {
      return nativeModules.HYLog.debug(params);
    } else {
      return new Promise(function (_resolve, reject) {
        reject({
          errorCode: -1,
          message: "HYLog.debug is not find in HYLog:".concat(JSON.stringify(nativeModules.HYLog))
        });
      });
    }
  },
  info: function info() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYLog && nativeModules.HYLog.info) {
      return nativeModules.HYLog.info(params);
    } else {
      return new Promise(function (_resolve, reject) {
        reject({
          errorCode: -1,
          message: "HYLog.info is not find in HYLog:".concat(JSON.stringify(nativeModules.HYLog))
        });
      });
    }
  },
  warn: function warn() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYLog && nativeModules.HYLog.warn) {
      return nativeModules.HYLog.warn(params);
    } else {
      return new Promise(function (_resolve, reject) {
        reject({
          errorCode: -1,
          message: "HYLog.warn is not find in HYLog:".concat(JSON.stringify(nativeModules.HYLog))
        });
      });
    }
  },
  error: function error() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYLog && nativeModules.HYLog.error) {
      return nativeModules.HYLog.error(params);
    } else {
      return new Promise(function (_resolve, reject) {
        reject({
          errorCode: -1,
          message: "HYLog.error is not find in HYLog:".concat(JSON.stringify(nativeModules.HYLog))
        });
      });
    }
  }
};

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var NativeEventCenter = nativeModules.HYNativeEventCenter;

var HYNativeEventCenter = /*#__PURE__*/function () {
  function HYNativeEventCenter() {
    var _this = this;

    classCallCheck(this, HYNativeEventCenter);

    this._nativeEventListeners = new Map();

    this._callback = function (params) {
      _this._dispatchEvent(params);
    };
  }

  createClass(HYNativeEventCenter, [{
    key: "addEventListener",
    value: function addEventListener(listener, eventName, callback) {
      if (!listener || !eventName || !callback) {
        return;
      }

      this._addEventEmitterListenerIfNeed();

      var listeners = this._nativeEventListeners.get(eventName);

      if (!listeners) {
        NativeEventCenter.addEventListener({
          'eventName': eventName
        });
        listeners = new Map();

        this._nativeEventListeners.set(eventName, listeners);
      }

      listeners.set(listener, callback);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(listener, eventName) {
      if (!listener || !eventName) {
        return;
      }

      var listeners = this._nativeEventListeners.get(eventName);

      if (listeners) {
        listeners.delete(listener);

        if (listeners.size == 0) {
          this._nativeEventListeners.delete(eventName);

          NativeEventCenter.removeEventListener({
            'eventName': eventName
          });
        }
      }

      this._removeEventEmitterListenerIfNeed();
    }
  }, {
    key: "clearEventListener",
    value: function clearEventListener(listener) {
      if (!listener) {
        return;
      }

      var emptyEvents = new Array();

      var _iterator = _createForOfIteratorHelper(this._nativeEventListeners.keys()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _eventName = _step.value;

          var listeners = this._nativeEventListeners.get(_eventName);

          if (listeners.size > 0) {
            listeners.delete(listener);

            if (listeners.size == 0) {
              emptyEvents.push(_eventName);
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      for (var index = 0; index < emptyEvents.length; index++) {
        var eventName = emptyEvents[index];

        this._nativeEventListeners.delete(eventName);

        NativeEventCenter.removeEventListener({
          'eventName': eventName
        });
      }
    }
  }, {
    key: "clearAllListener",
    value: function clearAllListener() {
      var _this2 = this;

      this._nativeEventListeners.forEach(function (value, key) {
        _this2._nativeEventListeners.delete(key);

        NativeEventCenter.removeEventListener({
          'eventName': key
        });
      });
    }
  }, {
    key: "postEventToNative",
    value: function postEventToNative(eventName, userInfo) {
      NativeEventCenter.postEvent({
        'eventName': eventName,
        'userInfo': userInfo
      });
    }
  }, {
    key: "_addEventEmitterListenerIfNeed",
    value: function _addEventEmitterListenerIfNeed() {
      if (this._nativeEventListeners.size == 0) {
        NativeEventCenter.on('nativeEvent', this._callback);
      }
    }
  }, {
    key: "_removeEventEmitterListenerIfNeed",
    value: function _removeEventEmitterListenerIfNeed() {
      if (this._nativeEventListeners.size == 0) {
        NativeEventCenter.off('nativeEvent', this._callback);
      }
    }
  }, {
    key: "_dispatchEvent",
    value: function _dispatchEvent(reminder) {
      var name = reminder.name;
      var params = reminder.params;

      var listeners = this._nativeEventListeners.get(name);

      if (!listeners) {
        return;
      }

      var _iterator2 = _createForOfIteratorHelper(listeners.keys()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var key = _step2.value;
          var callback = listeners.get(key);
          callback(params);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }]);

  return HYNativeEventCenter;
}();

var hyNativeEventCenter = new HYNativeEventCenter();

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var runtime = function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.

  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.

    generator._invoke = makeInvokeMethod(innerFn, self, context);
    return generator;
  }

  exports.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.

  var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.


  var IteratorPrototype = {};

  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

  if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction"; // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      prototype[method] = function (arg) {
        return this._invoke(method, arg);
      };
    });
  }

  exports.isGeneratorFunction = function (genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
    // do is to check its .name property.
    (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
  };

  exports.mark = function (genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;

      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }

    genFun.prototype = Object.create(Gp);
    return genFun;
  }; // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.


  exports.awrap = function (arg) {
    return {
      __await: arg
    };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;

        if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function (value) {
            invoke("next", value, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function (unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function (error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = // If enqueue has been called before, then we want to wait until
      // all previous Promises have been resolved before calling invoke,
      // so that results are always delivered in the correct order. If
      // enqueue has not been called before, then it is important to
      // call invoke immediately, without waiting on a callback to fire,
      // so that the async generator function has the opportunity to do
      // any necessary setup in a predictable way. This predictability
      // is why the Promise constructor synchronously invokes its
      // executor callback, and why async functions synchronously
      // execute code before the first await. Since we implement simple
      // async functions in terms of async generators, it is especially
      // important to get this right, even though it requires care.
      previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
      // invocations of the iterator.
      callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    } // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).


    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);

  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };

  exports.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.

  exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
    : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;
    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        } // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;

        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);

          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;
        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);
        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;
        var record = tryCatch(innerFn, self, context);

        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done ? GenStateCompleted : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };
        } else if (record.type === "throw") {
          state = GenStateCompleted; // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.

          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  } // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.


  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (!info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

      context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.

      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }
    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    } // The delegate iterator is finished, so forget it and continue with
    // the outer generator.


    context.delegate = null;
    return ContinueSentinel;
  } // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.


  defineIteratorMethods(Gp);
  Gp[toStringTagSymbol] = "Generator"; // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.

  Gp[iteratorSymbol] = function () {
    return this;
  };

  Gp.toString = function () {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{
      tryLoc: "root"
    }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function (object) {
    var keys = [];

    for (var key in object) {
      keys.push(key);
    }

    keys.reverse(); // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.

    return function next() {
      while (keys.length) {
        var key = keys.pop();

        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      } // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.


      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];

      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;
          return next;
        };

        return next.next = next;
      }
    } // Return an iterator with no values.


    return {
      next: doneResult
    };
  }

  exports.values = values;

  function doneResult() {
    return {
      value: undefined$1,
      done: true
    };
  }

  Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      this.prev = 0;
      this.next = 0; // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.

      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;
      this.method = "next";
      this.arg = undefined$1;
      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },
    stop: function stop() {
      this.done = true;
      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;

      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;

      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }
          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" || record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      } // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.


      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  }; // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.

  return exports;
}( // If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
 module.exports );

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}
});

var regenerator = runtime_1;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var asyncToGenerator = _asyncToGenerator;

/**
 * Implementation of atob() according to the HTML and Infra specs, except that
 * instead of throwing INVALID_CHARACTER_ERR we return null.
 */

function atob(data) {
  // Web IDL requires DOMStrings to just be converted using ECMAScript
  // ToString, which in our case amounts to using a template literal.
  data = "".concat(data); // "Remove all ASCII whitespace from data."

  data = data.replace(/[ \t\n\f\r]/g, ""); // "If data's length divides by 4 leaving no remainder, then: if data ends
  // with one or two U+003D (=) code points, then remove them from data."

  if (data.length % 4 === 0) {
    data = data.replace(/==?$/, "");
  } // "If data's length divides by 4 leaving a remainder of 1, then return
  // failure."
  //
  // "If data contains a code point that is not one of
  //
  // U+002B (+)
  // U+002F (/)
  // ASCII alphanumeric
  //
  // then return failure."


  if (data.length % 4 === 1 || /[^+/0-9A-Za-z]/.test(data)) {
    return null;
  } // "Let output be an empty byte sequence."


  var output = ""; // "Let buffer be an empty buffer that can have bits appended to it."
  //
  // We append bits via left-shift and or.  accumulatedBits is used to track
  // when we've gotten to 24 bits.

  var buffer = 0;
  var accumulatedBits = 0; // "Let position be a position variable for data, initially pointing at the
  // start of data."
  //
  // "While position does not point past the end of data:"

  for (var i = 0; i < data.length; i++) {
    // "Find the code point pointed to by position in the second column of
    // Table 1: The Base 64 Alphabet of RFC 4648. Let n be the number given in
    // the first cell of the same row.
    //
    // "Append to buffer the six bits corresponding to n, most significant bit
    // first."
    //
    // atobLookup() implements the table from RFC 4648.
    buffer <<= 6;
    buffer |= atobLookup(data[i]);
    accumulatedBits += 6; // "If buffer has accumulated 24 bits, interpret them as three 8-bit
    // big-endian numbers. Append three bytes with values equal to those
    // numbers to output, in the same order, and then empty buffer."

    if (accumulatedBits === 24) {
      output += String.fromCharCode((buffer & 0xff0000) >> 16);
      output += String.fromCharCode((buffer & 0xff00) >> 8);
      output += String.fromCharCode(buffer & 0xff);
      buffer = accumulatedBits = 0;
    } // "Advance position by 1."

  } // "If buffer is not empty, it contains either 12 or 18 bits. If it contains
  // 12 bits, then discard the last four and interpret the remaining eight as
  // an 8-bit big-endian number. If it contains 18 bits, then discard the last
  // two and interpret the remaining 16 as two 8-bit big-endian numbers. Append
  // the one or two bytes with values equal to those one or two numbers to
  // output, in the same order."


  if (accumulatedBits === 12) {
    buffer >>= 4;
    output += String.fromCharCode(buffer);
  } else if (accumulatedBits === 18) {
    buffer >>= 2;
    output += String.fromCharCode((buffer & 0xff00) >> 8);
    output += String.fromCharCode(buffer & 0xff);
  } // "Return output."


  return output;
}
/**
 * A lookup table for atob(), which converts an ASCII character to the
 * corresponding six-bit number.
 */


var keystr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

function atobLookup(chr) {
  var index = keystr.indexOf(chr); // Throw exception if character is not in the lookup string; should not be hit in tests

  return index < 0 ? undefined : index;
}

var atob_1 = atob;

/**
 * btoa() as defined by the HTML and Infra specs, which mostly just references
 * RFC 4648.
 */

function btoa(s) {
  var i; // String conversion as required by Web IDL.

  s = "".concat(s); // "The btoa() method must throw an "InvalidCharacterError" DOMException if
  // data contains any character whose code point is greater than U+00FF."

  for (i = 0; i < s.length; i++) {
    if (s.charCodeAt(i) > 255) {
      return null;
    }
  }

  var out = "";

  for (i = 0; i < s.length; i += 3) {
    var groupsOfSix = [undefined, undefined, undefined, undefined];
    groupsOfSix[0] = s.charCodeAt(i) >> 2;
    groupsOfSix[1] = (s.charCodeAt(i) & 0x03) << 4;

    if (s.length > i + 1) {
      groupsOfSix[1] |= s.charCodeAt(i + 1) >> 4;
      groupsOfSix[2] = (s.charCodeAt(i + 1) & 0x0f) << 2;
    }

    if (s.length > i + 2) {
      groupsOfSix[2] |= s.charCodeAt(i + 2) >> 6;
      groupsOfSix[3] = s.charCodeAt(i + 2) & 0x3f;
    }

    for (var j = 0; j < groupsOfSix.length; j++) {
      if (typeof groupsOfSix[j] === "undefined") {
        out += "=";
      } else {
        out += btoaLookup(groupsOfSix[j]);
      }
    }
  }

  return out;
}
/**
 * Lookup table for btoa(), which converts a six-bit number into the
 * corresponding ASCII character.
 */


var keystr$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

function btoaLookup(index) {
  if (index >= 0 && index < 64) {
    return keystr$1[index];
  } // Throw INVALID_CHARACTER_ERR exception here -- won't be hit in the tests.


  return undefined;
}

var btoa_1 = btoa;

var abab = {
  atob: atob_1,
  btoa: btoa_1
};
var abab_1 = abab.atob;
var abab_2 = abab.btoa;

var Taf = Taf || {};

Taf.INT8 = function () {
  this._clone = function () {
    return 0;
  };

  this._write = function (os, tag, val) {
    return os.writeInt8(tag, val);
  };

  this._read = function (is, tag, def) {
    return is.readInt8(tag, true, def);
  };

  this._className = function () {
    return Taf.CHAR;
  };
};

Taf.INT16 = function () {
  this._clone = function () {
    return 0;
  };

  this._write = function (os, tag, val) {
    return os.writeInt16(tag, val);
  };

  this._read = function (is, tag, def) {
    return is.readInt16(tag, true, def);
  };

  this._className = function () {
    return Taf.SHORT;
  };
};

Taf.INT32 = function () {
  this._clone = function () {
    return 0;
  };

  this._write = function (os, tag, val) {
    return os.writeInt32(tag, val);
  };

  this._read = function (is, tag, def) {
    return is.readInt32(tag, true, def);
  };

  this._className = function () {
    return Taf.INT32;
  };
};

Taf.INT64 = function () {
  this._clone = function () {
    return 0;
  };

  this._write = function (os, tag, val) {
    return os.writeInt64(tag, val);
  };

  this._read = function (is, tag, def) {
    return is.readInt64(tag, true, def);
  };

  this._className = function () {
    return Taf.INT64;
  };
};

Taf.UINT8 = function () {
  this._clone = function () {
    return 0;
  };

  this._write = function (os, tag, val) {
    return os.writeInt16(tag, val);
  };

  this._read = function (is, tag, def) {
    return is.readInt16(tag, true, def);
  };

  this._className = function () {
    return Taf.SHORT;
  };
};

Taf.UInt16 = function () {
  this._clone = function () {
    return 0;
  };

  this._write = function (os, tag, val) {
    return os.writeInt32(tag, val);
  };

  this._read = function (is, tag, def) {
    return is.readInt32(tag, true, def);
  };

  this._className = function () {
    return Taf.INT32;
  };
};

Taf.UInt32 = function () {
  this._clone = function () {
    return 0;
  };

  this._write = function (os, tag, val) {
    return os.writeInt64(tag, val);
  };

  this._read = function (is, tag, def) {
    return is.readInt64(tag, true, def);
  };

  this._className = function () {
    return Taf.INT64;
  };
};

Taf.Float = function () {
  this._clone = function () {
    return 0;
  };

  this._write = function (os, tag, val) {
    return os.writeFloat(tag, val);
  };

  this._read = function (is, tag, def) {
    return is.readFloat(tag, true, def);
  };

  this._className = function () {
    return Taf.FLOAT;
  };
};

Taf.Double = function () {
  this._clone = function () {
    return 0;
  };

  this._write = function (os, tag, val) {
    return os.writeDouble(tag, val);
  };

  this._read = function (is, tag, def) {
    return is.readDouble(tag, true, def);
  };

  this._className = function () {
    return Taf.DOUBLE;
  };
};

Taf.STRING = function () {
  this._clone = function () {
    return 0;
  };

  this._write = function (os, tag, val) {
    return os.writeString(tag, val);
  };

  this._read = function (is, tag, def) {
    return is.readString(tag, true, def);
  };

  this._className = function () {
    return Taf.STRING;
  };
};

Taf.BOOLEAN = function () {
  this._clone = function () {
    return false;
  };

  this._write = function (os, tag, val) {
    return os.writeBoolean(tag, val);
  };

  this._read = function (is, tag, def) {
    return is.readBoolean(tag, true, def);
  };

  this._className = function () {
    return Taf.BOOLEAN;
  };
};

Taf.ENUM = function () {
  this._clone = function () {
    return 0;
  };

  this._write = function (os, tag, val) {
    return os.writeInt32(tag, val);
  };

  this._read = function (is, tag, def) {
    return is.readInt32(tag, true, def);
  };
};
/**
 * TAFVECTOR实现类
 */


Taf.Vector = function (proto) {
  this.proto = proto;
  this.value = new Array();
};

Taf.Vector.prototype._clone = function () {
  return new Taf.Vector(typeof this.proto === 'function' ? new this.proto() : this.proto);
};

Taf.Vector.prototype._write = function (os, tag, val) {
  return os.writeVector(tag, val);
};

Taf.Vector.prototype._read = function (is, tag, def) {
  return is.readVector(tag, true, def);
};

Taf.Vector.prototype._className = function () {
  var clsName;

  if (typeof this.proto === 'function') {
    var obj = new this.proto();
    clsName = obj._className();
  } else {
    clsName = this.proto._className();
  }

  return Taf.TypeHelp.VECTOR.replace('$t', clsName);
};
/**
 * TAFMAP实现类
 */


Taf.Map = function (kproto, vproto) {
  this.kproto = kproto;
  this.vproto = vproto;
  this.value = new Object();
};

Taf.Map.prototype._clone = function () {
  return new Taf.Map(this.kproto, this.vproto);
};

Taf.Map.prototype._write = function (os, tag, val) {
  return os.writeMap(tag, val);
};

Taf.Map.prototype._read = function (is, tag, def) {
  return is.readMap(tag, true, def);
};

Taf.Map.prototype.put = function (key, value) {
  this.value[key] = value;
};

Taf.Map.prototype.get = function (key) {
  return this.value[key];
};

Taf.Map.prototype.remove = function (key) {
  delete this.value[key];
};

Taf.Map.prototype.clear = function () {
  this.value = new Object();
};

Taf.Map.prototype.size = function () {
  var anum = 0;

  for (var key in this.value) {
    anum++;
  }

  return anum;
};

Taf.Vector.prototype._className = function () {
  return Taf.TypeHelp.Map.replace('$k', this.kproto._className()).replace('$v', this.vproto._className());
};

/**
 * 将base64字符串转为对应的arrayBuffer对象
 * @function base64ToArrayBuffer
 * @memberof Utils
 * @param {string} base64 - base64编码的字符串
 * @returns {arrayBuffer} 二进制utf8的arraybuffer
 */

function base64ToArrayBuffer(base64) {
  var binary_string = abab_1(base64);
  var len = binary_string.length;
  var bytes = new Uint8Array(len);

  for (var i = 0; i < len; i++) {
    bytes[i] = binary_string.charCodeAt(i);
  }

  return bytes.buffer;
}
/**
 * 将ArrayBuffer转为对应的base64字符串
 * @function arrayBufferToBase64
 * @memberof Utils
 * @param {arrayBuffer} buffer - 二进制buffer对象
 * @returns {string}  base64编码的字符串
 */

function arrayBufferToBase64(buffer) {
  var binary = '';
  var bytes = new Uint8Array(buffer);
  var len = bytes.byteLength;

  for (var i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }

  return abab_2(binary);
}
function getWupStructByArrayBuffer(arrayBuffer, rspClass) {
  var wup = new Taf.Wup();
  wup.decode(arrayBuffer);
  var key = wup.newdata.get('tRsp') ? 'tRsp' : 'tResp';
  var wupStruct = new rspClass();
  wup.readStruct(key, wupStruct, rspClass);
  return wupStruct;
}
function createArrayBufferByWupReq(serventName, func, data) {
  var wup = new Taf.Wup();
  wup.setServant(serventName);
  wup.setFunc(func);
  wup.writeStruct('tReq', data);
  var os = wup.encode();
  return os.getBuffer();
}

var NativeDataCenter = nativeModules.HYDataCenter;

var HYDataCenter = /*#__PURE__*/function () {
  function HYDataCenter() {
    classCallCheck(this, HYDataCenter);
  }

  createClass(HYDataCenter, [{
    key: "setUserIdFunc",

    /**
     *设置获取UserID方法，
     *
     * @param {function} fun 获取UserID方法，fun返回Promise<HUYA.UserId>
     * @memberof HYDataCenter
     * 
     */
    value: function setUserIdFunc(fun) {
      this._userIdFun = fun;
    }
    /**
     *发起taf请求，会自动调用UserIdFunc设置UserId，UserId字段key为tId
     *
     * @param {*} cfg 请求配置
     * @param {*} strategy 缓存策略
     * @return {Promise<Object>} 成功即返回jce对象
     * @memberof HYDataCenter
    */

  }, {
    key: "sendWupRequest",
    value: function () {
      var _sendWupRequest = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(cfg, strategy) {
        var userId;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!cfg.request) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return this._userIdFun();

              case 3:
                userId = _context.sent;
                cfg.request.tId = userId;

              case 5:
                return _context.abrupt("return", this.sendWupRequestWithCustomUserId(cfg, strategy));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function sendWupRequest(_x, _x2) {
        return _sendWupRequest.apply(this, arguments);
      }

      return sendWupRequest;
    }()
    /**
     *发起taf请求，调用方自己设置request UserId
     *
     * @param {*} cfg {servant    : servant,funcname   : funcname,requestType : 0,cacheKey : "rn_huya_datacenter_userLevelInfo",request : req,rspClass : HUYA.GetUserLevelInfoRsp}
     * @param {*} strategy
     * @memberof HYDataCenter
     */

  }, {
    key: "sendWupRequestWithCustomUserId",
    value: function () {
      var _sendWupRequestWithCustomUserId = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(cfg, strategy) {
        var rspClass, request, arrayBuffer, arrayBufferStr, responseData, responseBuf, result, buf, resp;
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                rspClass = cfg.rspClass;
                request = cfg.request;
                arrayBuffer = createArrayBufferByWupReq(cfg.servant, cfg.funcname, request);
                arrayBufferStr = arrayBufferToBase64(arrayBuffer);
                cfg.unitPacket = arrayBufferStr;
                cfg.request = null;
                cfg.rspClass = null;
                _context2.prev = 7;
                _context2.next = 10;
                return NativeDataCenter.sendWupRequest(cfg, strategy);

              case 10:
                responseData = _context2.sent;
                responseBuf = base64ToArrayBuffer(responseData);
                result = getWupStructByArrayBuffer(responseBuf, rspClass);

                if (cfg.needLog) {
                  HYLog.info('HYRNDataCenter', 'sendRequest :\n' + JSON.stringify(request, null, 4) + '\n result : \n' + JSON.stringify(result, null, 4) + "\n strategy:" + strategy);
                }

                return _context2.abrupt("return", result);

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](7);

                try {
                  buf = base64ToArrayBuffer(_context2.t0.message);
                  resp = getWupStructByArrayBuffer(buf, rspClass);
                  _context2.t0.resp = resp;
                } catch (err) {
                  HYLog.info('HYRNDataCenter', 'decode resp failed:' + JSON.stringify(err));
                }

                HYLog.info("HYRNDataCenter", "error :" + JSON.stringify(_context2.t0));
                throw _context2.t0;

              case 22:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[7, 17]]);
      }));

      function sendWupRequestWithCustomUserId(_x3, _x4) {
        return _sendWupRequestWithCustomUserId.apply(this, arguments);
      }

      return sendWupRequestWithCustomUserId;
    }()
  }]);

  return HYDataCenter;
}();

var hyDataCenter = new HYDataCenter();

/** 
 * @author: Haisheng Ding  
 * @date: 2020-03-19 10:51:41  
 * @last modified by:   Haisheng Ding 
 * @last modified time: 2020-03-19 10:51:41 
 */

setup(); //基础能力

/** 
 * @author: Haisheng Ding  
 * @date: 2020-03-18 20:28:01  
 * @last modified by:   Haisheng Ding 
 * @last modified time: 2020-03-18 20:28:01 
 */
/**
 * 导出HUYASdk，兼容历史版本，历史版本直接通过HUYASdk调用api，新版本建议用ES6 Modules方式调用
 */

var HUYASdk$1 = {
  version: '1.0.0',
  //ios的wkwebview是否存在的话默认使用postMessage
  usePostMessageByDefault: true,
  //uiwebView支持protocol方式的bridge
  useProcolByDefault: false,
  //使用jsContext
  useContextByDefault: false,
  EVENT_ID: {},
  CONST_TYPE: {},
  //
  Browser: Browser,
  Utils: Utils,
  bridge: nativeBridge,
  JSBridge: nativeBridge,
  exportApi: function exportApi(api) {
    Utils.shallowExtend(HUYASdk$1, api);
  },
  exportEventID: function exportEventID(api) {
    Utils.shallowExtend(HUYASdk$1.EVENT_ID, api);
  },

  /**
       * 将对象混入到HUYASdk的CONST_TYPE属性，内部使用
       * @function 
       * @memberof HUYASdk
       * @param {object} api - 混入对象
       */
  exportConstType: function exportConstType(api) {
    Utils.shallowExtend(HUYASdk$1.CONST_TYPE, api);
  },

  /**
   * 打log，通过这种方式将log打到native日志
   * @function 
   * @memberof HUYASdk
   * @param {string} msg - log字符串
   */
  log: function log(msg) {
    nativeBridge.invoke('log', {
      'msg': msg
    });
  },

  /**
   * 监听huyasdk 注入完毕ready事件的回调
   * @function 
   * @memberof HUYASdk
   * @param {function} callback 
   */
  ready: function ready(callback) {
    addReadyEventListener(callback);
  },
  handleResponse: nativeBridge.handleResponse.bind(nativeBridge),
  wupRequstMap: {},
  uniqueWupRequstId: 0
};

/**
 * @file native cache相关
 * @author huangpengfei <huangpengfei@yy.com>
 */

(function (HUYASdk) {
  var JSBridge = HUYASdk.JSBridge;
  /**
   * HUYASdk的cache相关，暂时不建议使用，还未正式测试完毕
   * @namespace HUYACache
   * @mixes HUYASdk
   */

  var HUYACache = {
    /**
     * 添加cache
     * @function 
     * @memberof HUYACache
     * @param {JSBridgeReqParam} params 
     * @example
    HUYASdk.addCache({
    key : "",     // {string}
    value : "",   // {string}
    complete : function(resp) {
    }
    });
     */
    addCache: function addCache(params) {
      JSBridge.invoke("addCache", {
        key: params.key,
        value: params.value
      }, params);
    },
    hasCache: function hasCache(params) {
      JSBridge.invoke("hasCache", {
        key: params.key
      }, params);
    },

    /**
     * 查询某个key是否存在cache
     * @function 
     * @memberof HUYACache
     * @param {JSBridgeReqParam} params 
     * @example
    HUYASdk.getCache({
    key : "",     // {string}
    complete : function(resp) {
    if (resp.value) {
        //cache存在
    } else {
        //cache不存在
    }
    }
    });
     */
    getCache: function getCache(params) {
      JSBridge.invoke("getCache", {
        key: params.key
      }, params);
    },

    /**
     * 查询某个key是否存在cache
     * @function 
     * @memberof HUYACache
     * @param {JSBridgeReqParam} params 
     * @example
    HUYASdk.removeCache({
    key : "",     // {string}
    complete : function(resp) {
    }
    });
     */
    removeCache: function removeCache(params) {
      JSBridge.invoke("removeCache", {
        key: params.key
      }, params);
    },

    /**
     * 清空cache
     * @function 
     * @memberof HUYACache
     * @param {JSBridgeReqParam} params 
     * @example
    HUYASdk.clearCache({});
     */
    clearCache: function clearCache(params) {
      JSBridge.invoke("clearCache", {}, params);
    }
  };
  HUYASdk.exportApi(HUYACache);
})(HUYASdk$1);

/**
 * @file 频道相关函数
 * @author huangpengfei <huangpengfei@yy.com>
 */

(function (HUYASdk) {
  var JSBridge = HUYASdk.JSBridge;
  var HUYATransfer = {
    "sendToTransferService": function sendToTransferService(params) {
      JSBridge.invoke("sendToTransferService", {
        "serviceId": params.serviceId.toString(),
        "uri": params.uri.toString(),
        "data": params.data
      }, params);
    }
  };
  /**
   * HUYASdk工具对象
   * @namespace HUYAChannel
   * @mixes HUYASdk
   */

  var HUYAChannel = {
    "joinChannel": function joinChannel(params) {
      JSBridge.invoke("joinChannel", {
        "sid": params.sid.toString(),
        "subsid": params.subsid.toString(),
        "kickContext": params.kickContext ? params.kickContext : ""
      }, params);
    },
    "getChannelIds": function getChannelIds(params) {
      JSBridge.invoke("getChannelIds", {}, params);
    },
    "requestOnlineCount": function requestOnlineCount(params) {
      JSBridge.invoke("requestOnlineCount", {
        "subsid": params.subsid.toString(),
        "sid": params.sid.toString()
      }, params);
    },
    "requestPageUserInfo": function requestPageUserInfo(params) {
      JSBridge.invoke("requestPageUserInfo", {
        "subsid": params.subsid.toString(),
        "sid": params.sid.toString(),
        "pos": params.pos.toString(),
        "num": params.num.toString()
      }, params);
    },
    "requestChannelInfo": function requestChannelInfo(params) {
      JSBridge.invoke("requestChannelInfo", {
        "subsid": params.subsid.toString()
      }, params);
    },
    "subscribeApp": function subscribeApp(params) {
      JSBridge.invoke("subscribeApp", {
        serviceIds: params.serviceIds || []
      }, params);
    },
    "leaveChannel": function leaveChannel(params) {
      JSBridge.invoke("leaveChannel", {}, params);
    },

    /**
     * 使用service通道发wup请求
     * @function 
     * @memberof HUYAChannel
     * @param {JSBridgeReqParam} params 
     * @example
    //创建dolaunch请求类
    var req = new HUYA.LiveLaunchReq();  
    req.tLiveUB.eSource = HUYA.ELiveSource.WEB_HUYA;
    //将doLaunch转为arrayBuffer
    var arrayBuffer = createArrayBufferByWupReq("liveui", "doLaunch", req);
    //调用
    HUYASdk.sendWupRequest({
    unitPacket : arrayBuffer,   //对应请求必须是uniPacket的ArrayBuffer
    userInfo : {},            //只支持对象
    complete : function(resp) {
    //成功返回那么直接解包为HUYA.LiveLaunchRsp
    var launchRsp = getWupStructByArrayBuffer(resp.data, HUYA.LiveLaunchRsp);
    }
    });
     */
    "sendWupRequest": function sendWupRequest(params) {
      if (params.unitPacket instanceof ArrayBuffer) {
        params.userInfo = params.userInfo ? params.userInfo : {};
        var requestId = HUYASdk.uniqueWupRequstId++;
        HUYASdk.wupRequstMap[requestId] = params;
        params.userInfo.__wupBridgeRequestId = requestId; // console.log("sendWupRequest begin");
        // console.log(_arrayBufferToBase64(params.unitPacket));

        JSBridge.invoke("sendWupRequest", {
          unitPacket: HUYASdk.Utils.arrayBufferToBase64(params.unitPacket),
          userInfo: params.userInfo
        }, params);
      }
    },

    /**
     * 获取当前频道相关信息
     * @function 
     * @memberof HUYAChannel
     * @param {JSBridgeReqParam} params 
     * @example
     * HUYASdk.currentChannelInfo({
     *    complete : function(resp) {
     *    }
     * });
     * @example resp对象示例
     * {
     *   "aSid": "1261516128",
     *   "topSid": "1261516128",     //顶级频道
     *   "subSid": "1261516128",     //子频道
     *   "presenterId": 1261516128,  //主播uid
     *   "presenterName": "xxx",     //主播昵称 
     *   "currentNickName":"xxx",    //当前用户昵称
     *   "currentUid": 1261516128,   //当前用户uid 
     *   "currentLogoUrl": "http://...",    //当前用户头像
     *   "presenterLogoUrl": "http://...",  //主播头像
     *   "durationAfterJoinSuccess" : 1000000, //观看时长，秒
     *   "gameId" : "游戏Id"
     *   "subscribeState" : 1      //1,已订阅当前主播， 0，未订阅
     *   "isLiving" : 1            //1正在直播，0不在直播
     *  }
     */
    "currentChannelInfo": function currentChannelInfo(params) {
      JSBridge.invoke("currentChannelInfo", {}, params);
    },
    "micOpen": function micOpen(params) {
      JSBridge.invoke("micOpen", {}, params);
    },
    "micClose": function micClose(params) {
      JSBridge.invoke("micClose", {}, params);
    },

    /**
     * 送礼
     * @function 
     * @memberof HUYAChannel
     * @param {JSBridgeReqParam} params 
     * @example
     * HUYASdk.sendGift({
     *   giftId: 123456,
     *   giftCount : 1      
     * });
     */
    "sendGift": function sendGift(params) {
      JSBridge.invoke("sendGift", {
        "giftId": params.giftId.toString(),
        "giftCount": params.giftCount.toString()
      }, params);
    },
    "getInteractiveComData": function getInteractiveComData(params) {
      JSBridge.invoke("getInteractiveComData", {}, params);
    },

    /**
     * 订阅主播
     * @function 
     * @memberof HUYAChannel
     * @param {JSBridgeReqParam} params 
     * @example
     * HUYASdk.subscribePresenter({
     *    uid : 'xxxx', //uid的字符串
     *    complete : function(resp) {
     *         if (resp.code==0) {
     *            //订阅成功
     *        }
     *    }
     * });
     */
    "subscribePresenter": function subscribePresenter(params) {
      JSBridge.invoke("subscribePresenter", {
        "uid": params.uid
      }, params);
    },

    /**
     * 取消订阅
     * @function 
     * @memberof HUYAChannel
     * @param {JSBridgeReqParam} params 
     * @example
     * HUYASdk.unSubscribePresenter({
     *    uid : 'xxxx', //uid的字符串
     *    complete : function(resp) {
     *         if (resp.code==0) {
     *            //取消成功
     *        }
     *    }
     * });
     */
    "unSubscribePresenter": function unSubscribePresenter(params) {
      JSBridge.invoke("unSubscribePresenter", {
        "uid": params.uid
      }, params);
    },

    /**
     * 获取直播间截图
     * @function 
     * @memberof HUYAChannel
     * @param {JSBridgeReqParam} params 
     * @example
     * HUYASdk.getTipOffPicture({
     *    complete : function(resp) { 
     *         if(resp.errorCode == 0) {      //errorCode, 0获取成功，1获取失败
     *           console.log(resp.imageData); //imageData, base64格式的图片数据
     *         } else {
     *           console.log("Fail");
     *         }
     *    }
     * });
     */
    "getTipOffPicture": function getTipOffPicture(params) {
      JSBridge.invoke("getTipOffPicture", {}, params);
    },
    CHANNEL_EVENT_RESULT_TYPE: {
      CHANNEL_JOIN: "CHANNEL_JOIN",
      USER_ONLINE_COUNT: "USER_ONLINE_COUNT",
      CHANNEL_INFO: "CHANNEL_INFO",
      PAGE_USER_INFO: "PAGE_USER_INFO",
      NEED_KICKOFF_OTHER: "NEED_KICKOFF_OTHER",
      CHANNEL_KICKOFF: "CHANNEL_KICKOFF",
      CHANNEL_KICKOFF_BY_OTHER_CLIENT: "CHANNEL_KICKOFF_BY_OTHER_CLIENT",
      USER_MIC_OPEN: "USER_MIC_OPEN",
      USER_MIC_CLOSE: "USER_MIC_CLOSE",
      TEXT_MESSAGE: "TEXT_MESSAGE",
      SUBCHANNEL_CHANGED: "SUBCHANNEL_CHANGED"
    }
  };
  HUYASdk.exportApi(HUYAChannel);
  HUYASdk.exportApi(HUYATransfer);
  /**
   * wup广播监听调用参数
   * @namespace EVENT_WUP_TRANSMIT_PARAM
   * @class
   * @property {array}  subUris      - 需要监听的subUri列表
   */

  /**
   * wup广播监听返回对象
   * @namespace EVENT_WUP_TRANSMIT_RESP
   * @class
   * @property {string}  subUri      - 对应的subUri
   * @property {arrayBuffer}  data   - 返回对应subUri的arrayBuffer
   */

  /**
   * @namespace EVENT_ID 
   * @property {string}  WUP_TRANSMIT    - WUP广播通知事件id，对应的参数参见 {@link EVENT_WUP_TRANSMIT_PARAM}， 返回对象resp参见 {@link EVENT_WUP_TRANSMIT_RESP}
   */

  HUYASdk.exportEventID({
    TRANSMIT: "transmit",
    WUP_TRANSMIT: "transmitWup",
    CHANNEL: "channelEvent"
  });
})(HUYASdk$1);

/**
 * @file 公共信息相关
 * @author huangpengfei <huangpengfei@yy.com>
 */

(function (HUYASdk) {
  var JSBridge = HUYASdk.JSBridge;
  /**
   * HUYASdk工具对象
   * @namespace HUYACommom
   * @mixes HUYASdk
   */

  var HUYACommom = {
    /**
     * 获取
     * @function 
     * @memberof HUYACommom
     * @param {JSBridgeReqParam} params 
     * @example 以监听wup广播请求为例
    var kSecPackTypeActivityCommon = 1010002;
    HUYASdk.addEventListener(HUYASdk.EVENT_ID.WUP_TRANSMIT, {
    subUris : [kSecPackTypeActivityCommon]
    } , function(resp){
    console.log("=======  WUP_TRANSMIT =======");
    console.log(resp.data);
    if (resp.subUri && resp.subUri == kSecPackTypeActivityCommon) {
     //xxx为对应具体subUri的对象,例如 xxx = new ActivityTeamWar.JobRankPanel();
    var req = new HUYA.ActivityBroadcastReq();
    var is = new Taf.JceInputStream(resp.data);
    req.readFrom(is);
     //这个uri是应答包的数据，data是透传的unipackit
    TestOutPut(JSON.stringify(req) + "<br> ");
    console.log(JSON.stringify(req));
     if (req.lUri == 20161001) {
        // var buffer = new TextEncoder().encode(req.sMsg);
        var buffer = HUYASdk.Utils.base64ToArrayBuffer(req.sMsg);
        var is = new Taf.JceInputStream(buffer);
        var presenterMsg = new BestUnion.WarPresenterMsg();
        presenterMsg.readFrom(is);
        console.log("WarPresenterMsg");
        console.log(JSON.stringify(presenterMsg));
    };
    } 
    });
     */
    "addEventListener": function addEventListener(eventId, params, listener) {
      if (typeof params == 'function') {
        listener = params;
        params = {};
      }

      if (!params) {
        params = {};
      }

      params.useContextByDefault = HUYASdk.useContextByDefault;
      params.useProcolByDefault = HUYASdk.useProcolByDefault;
      params.usePostMessageByDefault = HUYASdk.usePostMessageByDefault; //这里要包裹一下

      if (eventId == HUYASdk.EVENT_ID.WUP_TRANSMIT) {
        var originListener = listener;

        listener = function listener(resp) {
          //wup透传回包数据是回包二进制流的base64字符串，需要做一次转换到ArrayBuffer
          if (resp.data) {
            resp.data = HUYASdk.Utils.base64ToArrayBuffer(resp.data);
          }

          if (resp.subUri && resp.subUri == 10000) {
            var userInfo = resp.userInfo;
            var requestId = userInfo.__wupBridgeRequestId;
            var reqParams = HUYASdk.wupRequstMap[requestId];

            if (reqParams) {
              HUYASdk.handleResponse(HUYASdk.EVENT_ID.WUP_TRANSMIT, resp, reqParams);
            }

            if (originListener) {
              originListener(resp);
            } //使用完就不需要了


            HUYASdk.wupRequstMap[requestId] = null;
          } else {
            if (originListener) {
              originListener(resp);
            }
          }
        };
      }

      JSBridge.on(eventId, params, listener);
    },
    "removeEventListener": function removeEventListener(eventId) {
      var params = {};
      params.useContextByDefault = HUYASdk.useContextByDefault;
      params.useProcolByDefault = HUYASdk.useProcolByDefault;
      params.usePostMessageByDefault = HUYASdk.usePostMessageByDefault;
      JSBridge.off(eventId, params);
    },

    /**
     * 获取
     * @function 
     * @memberof HUYACommom
     * @param {JSBridgeReqParam} params 
     * @example
     * HUYASdk.getAppInfo({
     *    complete : function(resp) {
     *    }
     * });
     * @example resp
     * {
     *    "status": "ok",
     *    "systemVersion": "9.2",
     *    "appVersion": "3.4.1",
     *    "err_code": 0,
     *    "appName" : "kiwi-ios",
     *    "huyaUA"  : "ua",
     *    "privilegeUseIAP" : 1    // 为1时，当前版本正在审核
     *  }
     */
    "getAppInfo": function getAppInfo(params) {
      JSBridge.invoke("getAppInfo", {}, params);
    },

    /**
     * 获取设备相关信息
     * @function 
     * @memberof HUYACommom
     * @param {JSBridgeReqParam} params 
     * @example
     * HUYASdk.getDeviceInfo({
     *    complete : function(resp) {
     *    }
     * });
     * @example resp
     *  {
     *      "idfa": "afsdfsfsfsf",  //只有ios才有
     *      "imei": "fsfsf",        //安卓才有
     *      "systemVersion" : "10.1.1",
     *      "guid" : "ssxas",
     *      "machineModel" : "iPhone X"
     *  }
     */
    "getDeviceInfo": function getDeviceInfo(params) {
      JSBridge.invoke("getDeviceInfo", {}, params);
    },

    /**
     * 调用native接口反馈信息
     * @function 
     * @memberof HUYACommom
     * @param {JSBridgeReqParam} params 
     * @example
     * HUYASdk.sendFeedBack({
     *    content  : "",        //反馈内容
     *    typeId   : '81',      //问题类型id （可选）
     *    typeName : '直播间',   //问题类型 （可选）
     *    picUrls  : 'xxx,xxx', //截图地址 （可选）
     *    contact  : '',        //联系方式 （可选）
     *    needProgress : '1',   //是否需要日志上传的提示 （可选，客服填1，其他不填，或填0）
     *    complete : function(resp) {
     *    }
     * });
     */
    "sendFeedBack": function sendFeedBack(params) {
      JSBridge.invoke("sendFeedBack", {
        content: params.content,
        typeId: params.typeId,
        typeName: params.typeName,
        picUrls: params.picUrls,
        contact: params.contact,
        needProgress: params.needProgress
      }, params);
    },

    /**
     * 将文本复制到剪切板
     * @function copyToClipboard
     * @memberof HUYACommom
     * @param {JSBridgeReqParam} 
     * @example
     * HUYASdk.copyToClipboard({
     *    text  : "xxx",    复制的文本
     * } 
     */
    "copyToClipboard": function copyToClipboard(params) {
      JSBridge.invoke("copyToClipboard", {
        text: params.text
      }, params);
    },

    /**
     *  获取当前网络
     * @function getCurrentNetworkType
     * @memberof HUYACommom
     * HUYASdk.getCurrentNetworkType({
     *    complete : function(resp) {
     *      //resp.networkType  // 0. 无网络，1. wifi, 2. 4g/3g
     *    }
     * });
     */
    "getCurrentNetworkType": function getCurrentNetworkType(params) {
      JSBridge.invoke("getCurrentNetworkType", {}, params);
    },

    /**
     * 通用接口，页面操作完后回调到app
     * 可在参数定制协议
     * @function operationCompleted
     * @memberof HUYACommom
     * HUYASdk.operationCompleted({
     *    resp: {}   
     * });
     */
    "operationCompleted": function operationCompleted(params) {
      JSBridge.invoke("operationCompleted", {
        resp: params.resp
      }, params);
    },

    /**
     * 获取手机卡识别码 (仅Android可用)
     * @function 
     * @memberof HUYACommom
     * @param {JSBridgeReqParam} params 
     * @example
     * HUYASdk.getImsi({
     *    complete : function(resp) {
     *       resp.imsi; //
     *    }
     * });
     */
    "getImsi": function getImsi(params) {
      JSBridge.invoke("getImsi", {}, params);
    },

    /**
     * 获取手机内网ip
     * @function 
     * @memberof HUYACommom
     * @param {JSBridgeReqParam} params 
     * @example
     * HUYASdk.getClientLocalIP({
     *    complete : function(resp) {
     *       resp.clientLocalIP; //
     *    }
     * });
     */
    "getClientLocalIP": function getClientLocalIP(params) {
      JSBridge.invoke("getClientLocalIP", {}, params);
    },

    /**
     * 前端统计使用，用于本页面的加载耗时统计
     * @function 
     * @memberof HUYACommom
     * @param {JSBridgeReqParam} params 
     * @example
     * HUYASdk.eventReport({
     *    event : xxx  
     *    complete : function(resp) {
     *    }
     * }); 
     * @available app-5.5.0
     */
    "eventReport": function eventReport(params) {
      JSBridge.invoke("eventReport", {
        event: params.event
      }, params);
    },

    /**
     * 前端使用app的上报通道
     * @function 
     * @memberof HUYACommom
     * @param {JSBridgeReqParam} params 
     * @example
     * HUYASdk.statisticReport({
     *    event : xxx,  
     *    type : '1', //按照前端原来的组包格式
     *    complete : function(resp) {
     *    }
     * }); 
     * @available app-6.9.0
     */
    "statisticReport": function statisticReport(params) {
      JSBridge.invoke("statisticReport", {
        event: params.event,
        type: params.type
      }, params);
    },

    /**
     * 设置当前webview在父视图的位置与大小
     * @praram x,y,width,height
     */
    "setWebViewFrame": function setWebViewFrame(params) {
      JSBridge.invoke("setWebViewFrame", {
        frame: params.frame
      }, params);
    },
    "setSafeAreaColor": function setSafeAreaColor(params) {
      JSBridge.invoke("setSafeAreaColor", {
        color: params.color,
        enabled: params.enabled
      }, params);
    },

    /**
     * 设置导航条是否透明
     * @function 
     * @memberof HUYACommom
     * @param {JSBridgeReqParam} params 
     * @example
     * HUYASdk.setNavigationBarTranslucent({
     *    translucent : true 
     * }); 
     * @available app-6.8.0
     */
    "setNavigationBarTranslucent": function setNavigationBarTranslucent(params) {
      JSBridge.invoke("setNavigationBarTranslucent", {
        translucent: params.translucent
      }, params);
    },

    /**
     * 当前是否在虎牙app内部
     * 这个接口在客户端脚本注入成功后才能使用
     * 在页面加载过程中慎用
     */
    "isInHuyaApp": function isInHuyaApp(params) {
      if (getBridge()) {
        return true;
      } else {
        return false;
      }
    },

    /**
     * toast
     * @function 
     * @memberof HUYACommom
     * @param {JSBridgeReqParam} params 
     * @example
     * HUYASdk.showToast({
     *    message : '提示内容'  
     * }); 
     * @available app-5.10.0
     */
    "showToast": function showToast(params) {
      JSBridge.invoke("showToast", {
        message: params.message
      }, params);
    },

    /**
     * startAudioRecord
     * @function 
     * @memberof HUYACommom
     * @param {JSBridgeReqParam} params 
     * @example
     * HUYASdk.startAudioRecord({complete:function(resp){ resp.code;//0, -1, -2 }}); 
     * @notice 
     * subscribe end event with AUDIO_RECORD_END, like:
     * HUYASdk.addEventListener(HUYASdk.EVENT_ID.AUDIO_RECORD_END, {} , function(resp){
     *  resp.status;
     *  resp.duration;
     *  resp.audioData;(base64)
     *
     * });
     * @available app-6.14.0
     */
    'startAudioRecord': function startAudioRecord(params) {
      JSBridge.invoke("startAudioRecord", {}, params);
    },

    /**
     * stopAudioRecord
     * @function 
     * @memberof HUYACommom
     * @param {JSBridgeReqParam} params 
     * @example
     * HUYASdk.stopAudioRecord(); 
     * @notice 
     * subscribe end event with AUDIO_RECORD_END, like:
     * HUYASdk.addEventListener(HUYASdk.EVENT_ID.AUDIO_RECORD_END, {} , function(resp){
     *  resp.status;
     *  resp.duration;
     *  resp.audioData;(base64)
     *
     * });
     * @available app-6.14.0
     */
    'stopAudioRecord': function stopAudioRecord(params) {
      JSBridge.invoke("stopAudioRecord", {}, params);
    },

    /**
     * cancelAudioRecord
     * @function cancel audio record , cancel subsribe and record data
     * @memberof HUYACommom
     * @param {JSBridgeReqParam} params 
     * @example
     * HUYASdk.cancelAudioRecord(); 
     * @available app-6.14.0
     */
    'cancelAudioRecord': function cancelAudioRecord(params) {
      JSBridge.invoke("cancelAudioRecord", {}, params);
    }
  };
  HUYASdk.exportApi(HUYACommom);
  /**
   * @namespace EVENT_ID 
   * @property {string}  VIEW_DISAPPEAR    - view将要消失
   * @property {string}  VIEW_APPEAR       - view显示
   * @property {string}  WILL_RESIGN_ACTIVE   - 准备退到后台
   * @property {string}  DID_BECOME_ACTIVE    - 进入前台
   * @property {string}  NETWORK_CHANGED      - 网络变化 
   */

  HUYASdk.exportEventID({
    VIEW_DISAPPEAR: "VIEW_DISAPPEAR",
    VIEW_APPEAR: "VIEW_APPEAR",
    WILL_RESIGN_ACTIVE: "WILL_RESIGN_ACTIVE",
    DID_BECOME_ACTIVE: "DID_BECOME_ACTIVE",
    NETWORK_CHANGED: "NETWORK_CHANGED",
    AUDIO_RECORD_END: "AUDIO_RECORD_END"
  });
  /**
   * 注册sendWupRequest的回调事件
   * 10000是约定sendWupRequest的回调的subUri
   */

  HUYASdk.addEventListener(HUYASdk.EVENT_ID.WUP_TRANSMIT, {
    subUris: [10000]
  }, function (resp) {});
})(HUYASdk$1);

/**
 * @file 一些配置
 * @author Loong <huanglonglong@huya.com>
 */

(function (HUYASdk) {
  var HUYAConfig = {
    APP_NAME: {
      GAME_IOS: "hyassist4game-ios",
      //手游iOS
      GAME_ANDROID: "game-adr",
      //手游安卓
      LIVE_IOS: "live-ios",
      //助手iOS
      LIVE_ANDROID: "live-adr",
      //助手安卓
      IOS: "kiwi-ios",
      //观众端iOS
      ANDROID: "kiwi-android",
      //观众端安卓
      Pitaya: "ios_pitaya",
      //小鹿陪玩iOS
      Pitaya_ANDROID: "adr_pitaya" //小鹿陪玩Android

    },
    //虎牙app
    isHuyaApp: function isHuyaApp(appName) {
      if (appName == this.APP_NAME.IOS || appName == this.APP_NAME.ANDROID) {
        return true;
      }

      return false;
    },
    //是小鹿陪玩
    isPitayaApp: function isPitayaApp(appName) {
      if (appName == this.APP_NAME.Pitaya || appName == this.APP_NAME.Pitaya_ANDROID) {
        return true;
      }

      return false;
    },
    //虎牙开播助手
    isHuyaLive: function isHuyaLive(appName) {
      if (appName == this.APP_NAME.LIVE_IOS || appName == this.APP_NAME.LIVE_ANDROID) {
        return true;
      }

      return false;
    },
    //虎牙手游开播
    isHuyaGame: function isHuyaGame(appName) {
      if (appName == this.APP_NAME.GAME_IOS || appName == this.APP_NAME.GAME_ANDROID) {
        return true;
      }

      return false;
    }
  };
  HUYASdk.HUYAConfig = HUYAConfig;
})(HUYASdk$1);

(function (HUYASdk) {
  var JSBridge = HUYASdk.JSBridge;
  var HUYAGameView = {
    "setVideoPosition": function setVideoPosition(params) {
      JSBridge.invoke("setVideoPosition", {
        "x": params.x.toString(),
        "y": params.y.toString()
      }, params);
    },
    "setVideoSize": function setVideoSize(params) {
      JSBridge.invoke("setVideoSize", {
        "width": params.width.toString(),
        "height": params.height.toString()
      }, params);
    },
    "setVideoVisibility": function setVideoVisibility(params) {
      JSBridge.invoke("setVideoVisibility", {
        "visibility": params.visibility.toString()
      }, params);
    },
    "setChatPosition": function setChatPosition(params) {
      JSBridge.invoke("setChatPosition", {
        "x": params.x.toString(),
        "y": params.y.toString()
      }, params);
    },
    "setChatSize": function setChatSize(params) {
      JSBridge.invoke("setChatSize", {
        "width": params.width.toString(),
        "height": params.height.toString()
      }, params);
    },
    "setChatVisibility": function setChatVisibility(params) {
      JSBridge.invoke("setChatVisibility", {
        "visibility": params.visibility.toString()
      }, params);
    },
    "getScreenSize": function getScreenSize(params) {
      JSBridge.invoke("getScreenSize", {}, params);
    },
    "setBackButtonVisibility": function setBackButtonVisibility(params) {
      JSBridge.invoke("setBackButtonVisibility", {
        "visibility": params.visibility.toString()
      }, params);
    }
  };
  HUYASdk.exportApi(HUYAGameView);
})(HUYASdk$1);

/**
 * @file 调起超粉RN页面
 * @author wangxiang <wangxiang@huya.com>
 */

(function (HUYASdk) {
  var JSBridge = HUYASdk.JSBridge;
  var HUYAInteractive = {
    /**
     * 调起超粉RN页面
     * @function 
     * @memberof HUYAInteractive
     * @param {JSBridgeReqParam} params 
     * @example
     * HUYASdk.openSuperFansPage({
     *   complete : function(resp) {
     *    }      
     * });
     */
    openSuperFansPage: function openSuperFansPage(params) {
      JSBridge.invoke("openSuperFansPage", {}, params);
    },

    /**
     * 关闭互动通道
     * @function 
     * @memberof HUYAInteractive
     * @param {JSBridgeReqParam} params 
     * @example
     * HUYASdk.hideInteractionPanel({
     *   complete : function(resp) {
     *    }      
     * });
     */
    hideInteractionPanel: function hideInteractionPanel(params) {
      JSBridge.invoke("hideInteractionPanel", {}, params);
    }
  };
  HUYASdk.exportApi(HUYAInteractive);
})(HUYASdk$1);

/**
 * @file 界面跳转相关
 * @author huangpengfei <huangpengfei@yy.com>
 */

(function (HUYASdk) {
  var JSBridge = HUYASdk.JSBridge;
  /**
   * HUYASdk界面跳转相关
   * @namespace HUYANativeJump
   * @mixes HUYASdk
   */

  var HUYANativeJump = {
    /**
     * 跳转登录界面
     * @function 
     * @memberof HUYANativeJump
     * @param {JSBridgeReqParam} params 
     * HUYASdk.showLogin({ type : 1}); //type: 1,快捷登录，0，跳转登录界面
     * @notice params可以不填，不填跟填type=0是一样的
     * @available app-5.5.0
     */
    "showLogin": function showLogin(params) {
      var info = params ? {
        type: params.type
      } : {};
      JSBridge.invoke("showLogin", info, params);
    },

    /**
     * 跳转充值界面
     * @function 
     * @memberof HUYANativeJump
     * @param {JSBridgeReqParam} params - 参数type:silver,ycoin,golden，默认跳转金豆
     */
    "showExchange": function showExchange(params) {
      //可选type值：silver,ycoin,golden，默认跳转金豆
      JSBridge.invoke("showExchange", {
        type: params.type
      });
    },

    /**
     * 退出当前webview
     * @function 
     * @memberof HUYANativeJump
     * @param {JSBridgeReqParam} params
     * @example
     * HUYASdk.quit({
     *      source : params.source, //来源
     *      data   : params.data    //透传数据
     *  });
     */
    "quit": function quit(params) {
      var info = params ? {
        source: params.source,
        data: params.data
      } : {};
      JSBridge.invoke("quit", info, params);
    },

    /**
     * 设置分享相关信息
     * @function 
     * @memberof HUYANativeJump
     * @param {JSBridgeReqParam} params
     * @example
     *  HUYASdk.setShareInfo({
     *       url: params.url,           //当前页面url
     *       isShow: params.isShow,     //是否显示
     *       title: params.title,       //标题
     *       content: params.content,   //内容 
     *       shareUrl: params.shareUrl, //分享链接
     *       imageUrl: params.imageUrl, //图片链接
     *       imageData: imageData,//分享图片的数据，图片数据的base64，当mediaType为2时，可填，若不填，则会从imageUrl下载
     *       mediaType: mediaType,//分享的媒体类型，1：web；2：image；3：emotion表情，微信适用；4：video视频；5：小程序；6：file文件，预留
     *       miniprogramUrl: miniprogramUrl, //小程序的url
     *   });
     */
    "setShareInfo": function setShareInfo(params) {
      var isShow = params.isShow;
      var type = typeof isShow; //ios全部转成'1','0'

      if (HUYASdk.Browser.versions.ios) {
        if (type != 'string') {
          if (isShow) {
            isShow = '1';
          } else {
            isShow = '0';
          }
        }
      } else {
        //android全部转成 true, false
        if (type == 'string') {
          isShow = parseInt(isShow);
        }

        isShow = Boolean(isShow);
      }

      JSBridge.invoke("setShareInfo", {
        url: params.url || window.location.href,
        //当前页面url
        isShow: isShow,
        //是否显示
        title: params.title,
        //标题
        content: params.content,
        //内容 
        shareUrl: params.shareUrl,
        //分享链接
        imageUrl: params.imageUrl,
        //图片链接
        imageData: params.imageData,
        miniprogramUrl: params.miniprogramUrl,
        mediaType: params.mediaType
      }, params);
    },

    /**
     * 分享到平台
     * @function
     * @memberof HUYANativeJump
     * @param {JSBridgeReqParam} parms
     * @example
     * HUYASdk.shareTo({
     *  	platform: platform,  //分享平台， 'weixin', 'circle', 'qq', 'qzone', 'sinaweibo', 'copy'
     *      title: title,        //标题
     *      content: content,    //内容 
     *      shareUrl: shareUrl,  //分享链接
     *      imageUrl: imageUrl,  //图片链接
     *      imageData: imageData,//分享图片的数据，图片数据的base64，当mediaType为2时，可填，若不填，则会从imageUrl下载
     *      mediaType: mediaType,//分享的媒体类型，1：web；2：image；3：emotion表情，微信适用；4：video视频；5：小程序；6：file文件，预留
     *      miniprogramUrl: miniprogramUrl, //小程序的url
     *      isShareImage: isShareImage, //是否以图片形式分享, 兼容旧版本使用, 新业务请勿使用
     *      needRequestShareUrl: needRequestShareUrl //是否需要请求url，app直播间分享使用
     * });
     */
    "shareTo": function shareTo(params) {
      HUYASdk.getAppInfo({
        complete: function complete(resp) {
          var isInHuyaApp = HUYASdk.HUYAConfig.isHuyaApp(resp.appName);

          if (isInHuyaApp) {
            //在ios 6.12/ adr 6.15 开始使用bridge的方式调用
            var isIOSVerionSupportBridge = HUYASdk.Browser.versions.ios && HUYASdk.Utils.versionCompare(resp.appVersion, '6.12.0') >= 0;
            var isAdrVerionSupportBridge = HUYASdk.Browser.versions.android && HUYASdk.Utils.versionCompare(resp.appVersion, '6.15.0') >= 0;

            if (isIOSVerionSupportBridge || isAdrVerionSupportBridge) {
              HUYASdk.shareToByBridge(params);
            } else {
              HUYASdk.shareToByUrl(params);
            }
          } else {
            //观众端 app以外均使用Bridge方式
            HUYASdk.shareToByBridge(params);
          }
        }
      });
    },
    "shareToByBridge": function shareToByBridge(params) {
      JSBridge.invoke("shareTo", {
        platform: params.platform,
        title: params.title,
        content: params.content,
        shareUrl: params.shareUrl,
        imageUrl: params.imageUrl,
        imageData: params.imageData,
        miniprogramUrl: params.miniprogramUrl,
        mediaType: params.mediaType
      }, params);
    },

    /**
     *  分享至 （拦截的方式）
     *  参数同shareTo，兼容旧版，新业务请使用shareTo
     */
    "shareToByUrl": function shareToByUrl(params) {
      HUYASdk.shareToSuccessCallback = function () {
        if (params.success) {
          params.success();
        }
      };

      var paramsObj = {
        needRequestShareUrl: params.needRequestShareUrl,
        shareUrl: params.shareUrl ? encodeURIComponent(params.shareUrl) : params.shareUrl,
        shareTitle: params.title,
        shareContent: params.content,
        shareImageUrl: params.imageUrl ? encodeURIComponent(params.imageUrl) : params.imageUrl,
        shareType: params.platform,
        isShareImage: params.isShareImage,
        shareCallback: "HUYASdk.shareToSuccessCallback()"
      };
      var url = "http://kiwijs.share.huya.com?";
      var shareUrl = HUYASdk.Utils.appendQueryString(url, paramsObj);
      window.location = shareUrl;
    },

    /**
     * 开通贵族界面
     * @function 
     * @memberof HUYANativeJump
     * @param {JSBridgeReqParam} params
     * @example
     * HUYASdk.showPrivileges({
     *      type: params.type,                      //取值用 HUYASdk.CONST_TYPE.Privileges_Type.Open 或者 HUYASdk.CONST_TYPE.Privileges_Type.Renew
     *      needYYCoin: params.needYYCoin,          //需要支付多少钱
     *      nobleLevel: params.nobleLevel,          //贵族等级
     *      nobleName: params.nobleName,            //贵族等级对应的名字
     *      transmitData: params.transmitData,      //h5透传给永傍那边的数据
     *      needBackRefresh: params.needBackRefresh //返回页面时是否需要刷新
     *  });
     */
    "showPrivileges": function showPrivileges(params) {
      if (typeof params.type == "string") {
        params.type = parseFloat(params.type, 10);
      }

      JSBridge.invoke("showPrivileges", {
        type: params.type,
        needYYCoin: params.needYYCoin,
        nobleLevel: params.nobleLevel,
        nobleName: params.nobleName,
        transmitData: params.transmitData,
        needBackRefresh: params.needBackRefresh
      }, params);
    },

    /**
     * 开通守护界面
     * @function 
     * @memberof HUYANativeJump
     * @param {JSBridgeReqParam} params
     * @example
    HUYASdk.showGuard({
    type: params.type,                          //取值用 HUYASdk.CONST_TYPE.Privileges_Type.Open 或者 HUYASdk.CONST_TYPE.Privileges_Type.Renew
    needYYCoin: params.needYYCoin,              //需要支付多少钱
    guardLevelBefore: params.guardLevelBefore,  //原来的等级
    guardLevel: params.guardLevel,              //守护等级
    transmitData: params.transmitData,          //h5透传给永傍那边的数据
    needBackRefresh: params.needBackRefresh     //返回页面时是否需要刷新
    month: params.month                         //续费月份
    presenterUid: params.presenterUid,          //主播uid
    presenterNick: params.presenterNick,        //主播昵称
    presenterYYId: params.presenterYYId         //主播yy号
    });
     */
    "showGuard": function showGuard(params) {
      if (typeof params.type == "string") {
        params.type = parseFloat(params.type, 10);
      }

      JSBridge.invoke("showGuard", {
        type: params.type,
        needYYCoin: params.needYYCoin,
        guardLevelBefore: params.guardLevelBefore,
        guardLevel: params.guardLevel,
        transmitData: params.transmitData,
        needBackRefresh: params.needBackRefresh,
        month: params.month,
        presenterUid: params.presenterUid,
        presenterNick: params.presenterNick,
        presenterYYId: params.presenterYYId
      }, params);
    },

    /**
     * 内部通用跳转协议
     * @function 
     * @memberof HUYANativeJump
     * @param {JSBridgeReqParam} params
     * @example
    HUYASdk.openUrl({
    url: params.type  //虎牙内部跳转协议,例如yykiwi://xxx
    });
     */
    "openUrl": function openUrl(params) {
      var url = params.url; //如果是内嵌页面，那么通过banneraction跳转

      if (getBridge()) {
        //如果是安卓那么要用banneraction去跳
        //如果是iOS用banneraction去跳由于iOS的bug会有二次转义，这里做兼容还原过来
        if (url.indexOf("yykiwi://openurl?banneraction") < 0) {
          if (HUYASdk.Browser.versions.android) {
            url = "yykiwi://openurl?banneraction=" + encodeURIComponent(url);
          }
        } else {
          if (HUYASdk.Browser.versions.ios) {
            var banneraction = HUYASdk.Utils.getParameterByName("banneraction", url);

            if (banneraction && banneraction.length) {
              url = banneraction;
            }
          }
        }
      }

      JSBridge.invoke("openUrl", {
        url: url
      }, params);
    },

    /**
     * 获取最近一次直播间相关信息
     * @function 
     * @memberof HUYANativeJump
     * @param {JSBridgeReqParam} params
     * @example
    HUYASdk.getJumpChannelInfo({
    complete : function(resp) {
    }
    });
     * @example resp对象示例
    {
    anchoruid : 1224,
    channelid : 122,
    subchannelid  : 1212,
    presentername : "奋斗"
    }
     */
    "getJumpChannelInfo": function getJumpChannelInfo(params) {
      JSBridge.invoke("getJumpChannelInfo", {}, params);
    },

    /**
     * 显示礼物面板
     * @function 
     * @memberof HUYANativeJump
     * @param {JSBridgeReqParam} params 
     * @available app-5.5.0
     */
    "showGiftPanel": function showGiftPanel(params) {
      JSBridge.invoke("showGiftPanel", {}, params);
    }
  };
  HUYASdk.exportApi(HUYANativeJump);
  HUYASdk.exportConstType({
    Privileges_Type: {
      Open: 1,
      Renew: 2
    }
  });
})(HUYASdk$1);

/**
 * @file 横屏活动相关接口，兼容老版本
 * @author huangpengfei <huangpengfei@yy.com>
 */

(function (context) {
  if (!/ipad|ipod|iphone/g.test(navigator.userAgent.toLowerCase())) {
    return;
  }

  context.activeClient = {
    InfoTypeConst: {
      token: 1,
      config: 2,
      authorInfo: 3
    },
    close: function close() {
      HUYASdk$1.bridge.invoke("close", {}, {});
    },
    updateConfig: function updateConfig(jsonStr) {
      HUYASdk$1.bridge.invoke("updateConfig", jsonStr, {});
    },

    /*
     * callback(response) : 鐧婚檰鍚庢垚鍔熻繑鍥炵殑鍥炶皟
     */
    login: function login(callback) {
      HUYASdk$1.bridge.invoke("login", {}, {});
    },
    getInfo: function getInfo(type, callback) {
      HUYASdk$1.bridge.invoke("getInfo", {
        type: type
      }, {
        complete: function complete(resp) {
          if (callback) {
            callback(resp);
          }
        }
      });
    },
    processUrl: function processUrl(url) {
      HUYASdk$1.bridge.invoke("processUrl", {
        url: url
      }, {});
    }
  };
})(window);

(function (app, context) {
  function extend() {
    var target = arguments[0] || {},
        options = arguments[1];

    for (var key in options) {
      var value = options[key];
      target[key] = value;
    }
  }

  var deviceInfo = function deviceInfo() {
    var ua = navigator.userAgent.toLowerCase(),
        browserInfo = {};
    browserInfo.isAndroid = /android/g.test(ua);
    browserInfo.isIphone = /ipad|ipod|iphone/g.test(ua);
    return browserInfo;
  };

  function External(type) {
    this.init();
  }

  extend(External.prototype, {
    init: function init() {},
    android: {
      close: function close() {
        if (app.activeClient) {
          app.activeClient.close();
        } else {
          return;
        }
      },
      getToken: function getToken(callback) {
        if (app.activeClient) {
          if (typeof callback == 'function') {
            callback(app.activeClient.getInfo(1));
          }
        } else {
          return;
        }
      },
      getCurrentConfig: function getCurrentConfig(callback) {
        if (app.activeClient) {
          if (typeof callback == 'function') {
            callback(JSON.parse(app.activeClient.getInfo(2)));
          }
        } else {
          return;
        }
      },
      updateConfig: function updateConfig(config) {
        if (app.activeClient) {
          app.activeClient.updateConfig(JSON.stringify(config));
        } else {
          return;
        }
      },
      getAuthorInfo: function getAuthorInfo(callback) {
        if (app.activeClient) {
          if (typeof callback == 'function') {
            callback(JSON.parse(app.activeClient.getInfo(3)));
          }
        } else {
          return;
        }
      },
      showLogin: function showLogin() {
        if (app.activeClient) {
          app.activeClient.login();
        } else {
          return;
        }
      },
      jumpToWebView: function jumpToWebView(url) {
        if (app.activeClient) {
          app.activeClient.processUrl(url);
        } else {
          return;
        }
      }
    },
    iphone: {
      close: function close() {
        console.log("===ios close===");
        app.activeClient.close();
      },
      getToken: function getToken(callback) {
        var token;
        app.activeClient.getInfo(activeClient.InfoTypeConst.token, function (response) {
          if (response.code === 0) {
            token = response.data;

            if (typeof callback == 'function') {
              callback(token);
            }
          }
        });
      },
      getCurrentConfig: function getCurrentConfig(callback) {
        var config;
        app.activeClient.getInfo(activeClient.InfoTypeConst.config, function (response) {
          if (response.code === 0) {
            config = response.data;

            if (typeof callback == 'function') {
              callback(config);
            }
          }
        });
      },
      getAuthorInfo: function getAuthorInfo(callback) {
        var authorInfo;
        app.activeClient.getInfo(activeClient.InfoTypeConst.authorInfo, function (response) {
          if (response.code === 0) {
            authorInfo = response.data;

            if (typeof callback == 'function') {
              callback(authorInfo);
            }
          }
        });
      },
      updateConfig: function updateConfig(config) {
        app.activeClient.updateConfig(config);
      },
      showLogin: function showLogin() {
        app.activeClient.login(function (response) {
          if (response.code === 0) ;
        });
      },
      jumpToWebView: function jumpToWebView(url) {
        app.activeClient.processUrl(url);
      }
    }
  });
  /**
   * HUYASdk横屏活动相关接口，主要是为了兼容老版本，仍然保留原来的调用方式
   * @class LandscapeActivity
   * @example
  //需要new出对象才能使用，建议只初始化一个实例
  //因为每创建一个实例就会去和native那一次数据，这些数据拿过一次是不会变的，不需要重复获取
  var activity = new HUYASdk.LandscapeActivity();
  //等待ready事件在回调函数中即可拿到相关信息
  activity.ready(function(){
  
  });
   */

  function HDappSdk() {
    this.init();
  }

  extend(HDappSdk.prototype, {
    init: function init() {
      var _deviceInfo = deviceInfo(),
          deviceType;

      this.token = '';
      this.currentConfig = null;
      this.authorInfo = null;

      if (_deviceInfo.isAndroid) {
        deviceType = 'android';
      } else if (_deviceInfo.isIphone) {
        deviceType = 'iphone';
      }

      this.deviceType = deviceType;
      this.external = new External(deviceType);

      this._getToken();

      this._getCurrentConfig();

      this._getAuthorInfo();
    },
    close: function close() {
      var t = this;
      t.external[t.deviceType].close();
    },
    _getToken: function _getToken() {
      var t = this;
      t.external[t.deviceType].getToken(function (res) {
        t.token = res; //alert(res)
      });
    },
    _getCurrentConfig: function _getCurrentConfig() {
      var t = this;
      t.external[t.deviceType].getCurrentConfig(function (res) {
        t.currentConfig = res;
      });
    },
    _getAuthorInfo: function _getAuthorInfo() {
      var t = this;
      t.external[t.deviceType].getAuthorInfo(function (res) {
        t.authorInfo = res;
      });
    },
    getAuthorInfo: function getAuthorInfo(callback) {
      var t = this;
      t.external[t.deviceType].getAuthorInfo(function (res) {
        callback(res);
      });
    },
    isLogin: function isLogin() {
      var t = this;

      if (t.token) {
        return true;
      } else {
        return false;
      }
    },
    updateConfig: function updateConfig(config) {
      var t = this;
      t.external[t.deviceType].updateConfig(config);
    },

    /**
     * 跳转到登录界面
     * @memberof LandscapeActivity
     */
    showLogin: function showLogin() {
      var t = this;
      t.external[t.deviceType].showLogin();
    },

    /**
     * 跳转到webview
     * @memberof LandscapeActivity
     * @param {string} url  - 跳转url
     */
    jumpToWebView: function jumpToWebView(url) {
      var t = this;
      t.external[t.deviceType].jumpToWebView(url);
    },

    /**
     * 分享
     * @memberof LandscapeActivity
     * @param {object} obj  - 分享参数
     * @example
    activity.share({
    title: '',
    url: location.href,
    content: '',
    callbackName: '',
    type: 'sinaweibo'
    });
     */
    share: function share(obj) {
      var shareInfo = {
        title: '',
        url: location.href,
        content: '',
        callbackName: '',
        type: 'sinaweibo'
      };
      HUYASdk$1.Utils.shallowExtend(shareInfo, obj);
      window.location.href = 'http://kiwijs.share.huya.com/?shareUrl=' + encodeURIComponent(shareInfo.url) + '&shareTitle=' + shareInfo.title + ' &shareContent=' + shareInfo.content + '&shareCallback=' + shareInfo.callbackName + '&shareType=' + shareInfo.type;
    },

    /**
     * 注册ready回调，回调完成后会返回appInfo相关信息
     * @memberof LandscapeActivity
     * @param {string} callback  - 回调函数
     * @example
    activity.ready(function(AppInfo){
    });
     * @example AppInfo例子
    {
    authorInfo : {
    aSid : 111,
    topSid : 11,
    subSid : 11,
    presenterId : 11,
    presenterName : "",
    currentNickName : "",
    currentUid : 111
    },
    token : "fdfdf"
    }
     */
    ready: function ready(callback) {
      var t = this,
          appInfo = {};
      var timmer = setInterval(function () {
        if (t.authorInfo) {
          appInfo = {
            authorInfo: t.authorInfo,
            token: t.token
          };

          if (typeof callback == 'function') {
            callback(appInfo);
          }

          clearInterval(timmer);
        }
      }, 50);
    }
  });
  /**
   * @memberof HUYASdk
   * @property {LandscapeActivity} LandscapeActivity
   */

  context.LandscapeActivity = HDappSdk;
})(window, HUYASdk$1);

/**
 * @file 第三方应用下载相关，仅限安卓使用
 * @author huangpengfei <huangpengfei@yy.com>
 */

(function (HUYASdk) {
  var JSBridge = HUYASdk.JSBridge;
  /**
   * HUYASdk的第三方应用相关
   * @namespace HUYANativeInstaller
   * @mixes HUYASdk
   */

  var HUYANativeInstaller = {
    /**
     * 获取下载信息
     * @function 
     * @memberof HUYANativeInstaller
     * @param {JSBridgeReqParam} params 
     */
    getAppDownloadInfo: function getAppDownloadInfo(params) {
      JSBridge.invoke("getAppDownloadInfo", {
        packageName: params.packageName,
        url: params.url,
        name: params.name
      }, params);
    },

    /**
     * 开始下载
     * @function 
     * @memberof HUYANativeInstaller
     * @param {JSBridgeReqParam} params 
     */
    startDownload: function startDownload(params) {
      JSBridge.invoke("startDownload", {
        url: params.url,
        name: params.name,
        fileMd5: params.fileMd5,
        extra: params.extra
      }, params);
    },

    /**
     * 暂停下载
     * @function 
     * @memberof HUYANativeInstaller
     * @param {JSBridgeReqParam} params 
     */
    pauseDownload: function pauseDownload(params) {
      JSBridge.invoke("pauseDownload", {
        url: params.url,
        name: params.name
      }, params);
    },

    /**
     * 暂停所有下载
     * @function 
     * @memberof HUYANativeInstaller
     * @param {JSBridgeReqParam} params 
     */
    pauseAllDownload: function pauseAllDownload(params) {
      JSBridge.invoke("pauseAllDownload", {}, params);
    },

    /**
     * 安装apk
     * @function 
     * @memberof HUYANativeInstaller
     * @param {JSBridgeReqParam} params 
     */
    intallApk: function intallApk(params) {
      JSBridge.invoke("intallApk", {
        name: params.name,
        packageName: params.packageName
      }, params);
    },

    /**
     * 启动应用
     * @function 
     * @memberof HUYANativeInstaller
     * @param {JSBridgeReqParam} params 
     */
    startApp: function startApp(params) {
      JSBridge.invoke("startApp", {
        packageName: params.packageName
      }, params);
    },

    /**
     * 取消下载
     * @function 
     * @memberof HUYANativeInstaller
     * @param {JSBridgeReqParam} params 
     */
    cancelDownLoad: function cancelDownLoad(params) {
      JSBridge.invoke("cancelDownLoad", {
        url: params.url
      }, params);
    },

    /**
     * 取消所有下载
     * @function 
     * @memberof HUYANativeInstaller
     * @param {JSBridgeReqParam} params 
     */
    cancelAllDownload: function cancelAllDownload(params) {
      JSBridge.invoke("cancelAllDownload", {}, params);
    },

    /**
     * 获取游戏订单信息
     * @function 
     * @memberof HUYANativeInstaller
     * @param {JSBridgeReqParam} params 
     */
    getGameSdkOrderInfo: function getGameSdkOrderInfo(params) {
      JSBridge.invoke("getGameSdkOrderInfo", {}, params);
    },

    /**
     * 通知native支付状态
     * @function 
     * @memberof HUYANativeInstaller
     * @param {JSBridgeReqParam} params 
     */
    callbackGameSdkPayResult: function callbackGameSdkPayResult(params) {
      JSBridge.invoke("callbackGameSdkPayResult", {
        orderInfo: params.orderInfo,
        payResult: params.payResult
      }, params);
    },

    /**
     *  是否能打开app
     *  @function 
     *  @memberof HUYANativeInstaller
     *  @param {JSBridgeReqParam} params 
     *  @example
     *  HUYASdk.canOpenApp({
     *     appkey : xxx, //scheme或包名
     *     complete : function(resp) {
     *       resp.canOpen;
     *     }
     *  }); 
     * @available app-7.0.0
     */
    canOpenApp: function canOpenApp(params) {
      JSBridge.invoke("canOpenApp", {
        appkey: params.appkey //传入scheme或包名

      }, params);
    }
  };
  /**
   * @namespace EVENT_ID 
   * @property {string}  NATIVE_INSTALLER    - APK状态变化事件
   */

  HUYASdk.exportEventID({
    NATIVE_INSTALLER: "INSTALL_APK_EVENT_CHANGED"
  });
  HUYASdk.exportApi(HUYANativeInstaller);
})(HUYASdk$1);

/**
 * @file 竖屏活动相关接口
 * @author huangpengfei <huangpengfei@yy.com>
 */

(function (HUYASdk) {
  var JSBridge = HUYASdk.JSBridge;
  /**
   * HUYASdk竖屏活动
   * @namespace HUYAChannelActivity
   * @mixes HUYASdk
   */

  var HUYAChannelActivity = {
    /**
     * @namespace EVENT_ID 
     * @property {string}  ACTIVITY_EVENT_ID.ACTIVITY_WINDOW_SIZE_CHANGED    - 活动页面展开收起回调
     */
    ACTIVITY_EVENT_ID: {
      //活动页展开收起状态发生变化
      ACTIVITY_WINDOW_SIZE_CHANGED: "ACTIVITY_WINDOW_SIZE_CHANGED"
    },

    /**
     * 当前活动页是否被展开
     * @memberof HUYAChannelActivity
     * @param {string} url  - 跳转url
     * @example
    HUYASdk.isActivityWindowExpanded({
    complete : function(resp) {
    var expanded = resp.expanded;
    }
    });
     */
    isActivityWindowExpanded: function isActivityWindowExpanded(params) {
      JSBridge.invoke("isActivityWindowExpanded", {}, params);
    },

    /**
     * 展开(收起)活动页
     * @memberof HUYAChannelActivity
     * @example
    HUYASdk.expandActivityWindow({
    expand : true,
    complete : function(resp) {
    }
    });
     */
    expandActivityWindow: function expandActivityWindow(params) {
      JSBridge.invoke("expandActivityWindow", {
        expand: params.expand
      }, params);
    }
  };
  HUYASdk.exportApi(HUYAChannelActivity);
  /**
   * HUYASdk竖屏活动
   * @namespace PortraitActivity
   */

  /**
   * @memberof HUYASdk
   * @property {PortraitActivity} PortraitActivity
   */

  HUYASdk.PortraitActivity = {
    /**
     * 使用通用协议跳转界面，这个接口所有版本的竖屏直播间都兼容，以后会废弃掉
     * @memberof PortraitActivity
     * @param {string} url  - 跳转url
     * @example
    HUYASdk.PortraitActivity.jump({
    needUdbCookie : false ,   //是否需要udb的cookie
    url :                     //要跳转的url，传原始字符串即可
    });
     */
    jump: function jump(obj) {
      var params = {
        needUdbCookie: obj.needUdbCookie,
        url: obj.url,
        title: obj.title || ""
      };

      if (!params.url) {
        return;
      }

      var jumpUrl = params.url;

      if (params.needUdbCookie) {
        jumpUrl = HUYASdk.Browser.versions.android ? encodeURIComponent(params.url) : params.url;
        jumpUrl = 'https://lgn.huya.com/lgn/jump/authentication.do?ticket=&appid=5060&busiId=&busiUrl=' + encodeURIComponent(jumpUrl) + '&yyuid=&reqDomainList=huya.com&action=authenticate';
      }

      var url = 'http://kiwijs.jump.huya.com/?jumpTitle=' + encodeURIComponent(params.title) + '&jumpUrl=' + encodeURIComponent(jumpUrl);
      location.href = url;
    },

    /**
     * 默认半屏页面是隐藏的，调用这个接口后界面才会显示出来
     * @memberof PortraitActivity
     * @param {string} url  - 跳转url
     * @example
    HUYASdk.PortraitActivity.show();
     */
    show: function show() {
      if (!getBridge()) {
        //如果客户端还没注入，则走拦截的方式
        location.href = "http://kiwijs.domready.huya.com/";
        return;
      }

      HUYASdk.getAppInfo({
        complete: function complete(resp) {
          if (resp.appVersion) {
            var limitVersion = '5.10.0'; //5.10以上版本才支持jssdk回调

            if (HUYASdk.Utils.versionCompare(resp.appVersion, limitVersion) >= 0) {
              JSBridge.invoke("show", {}, {});
            } else {
              location.href = "http://kiwijs.domready.huya.com/";
            }
          } else {
            location.href = "http://kiwijs.domready.huya.com/";
          }
        }
      });
    }
  };
})(HUYASdk$1);

/**
 * @file 第三方相关调用，所有集成了第三方的全部放在这个里面
 * @author panzhiyong <panzhiyong@huya.com>
 */

(function (HUYASdk) {
  var JSBridge = HUYASdk.JSBridge;
  var HUYAThirdInvoke = {
    PLATFORM: "5",
    //虎牙
    //************************王者荣耀调起开黑**********************************//

    /**
     * 调起王者荣耀，进入开黑
     * @function 
     * @memberof HUYAThirdInvoke
     * @param {JSBridgeReqParam} params 
     * @example
     * HUYASdk.joinGangup({
     *   openId: '从后台拿',
     *   token : '从后台拿',
     *   roomId: '从后台拿',
     *   accType:'从后台拿',
     *   complete : function(resp) {
     *         if (resp.code==0) {
     *            //调起成功
     *         }
     *    }      
     * });
     */
    joinGangup: function joinGangup(params) {
      JSBridge.invoke("joinGangup", {
        "openId": params.openId.toString(),
        "token": params.token.toString(),
        "roomId": params.roomId.toString(),
        "platform": this.PLATFORM,
        "accType": params.accType.toString()
      }, params);
    }
  }; //************************王者荣耀调起开黑**********************************//

  HUYASdk.exportApi(HUYAThirdInvoke);
})(HUYASdk$1);

/**
 * @file 用户信息相关
 * @author huangpengfei <huangpengfei@yy.com>
 */

(function (HUYASdk) {
  /**
   * HUYASdk的用户信息相关
   * @namespace HUYAUser
   * @mixes HUYASdk
   */
  var JSBridge = HUYASdk.JSBridge;
  var HUYAUser = {
    /**
     * 获取当前登陆用户相关信息
     * @function 
     * @memberof HUYAUser
     * @param {JSBridgeReqParam} params 
     * @example
     * HUYASdk.getCurrentUserInfo({
     *    complete : function(resp) {
     *    }
     * });
     * @example resp对象示例
     * {
     *   "imid": 424824622,
     *   "uid": 501925061,
     *   "status": "ok",
     *   "err_code": 0,
     *   "udbToken": "xxx",
     *   "ticketType": "1",
     *   "avatarUrl":"xxx",
     *   "sex": "女",
     *   "name": "testrob",
     *   "sign": "",
     *   "userLevel": 0,
     *   "userCurrentExp": 0,
     *   "nextLevelExp": 0,
     *   "dailyExp": 0,
     *   "nobleInfo" : {
     *      isNoble:true,    //是否是贵族
     *      uid:123,         //用户uid
     *      validDate:1233,  //贵族有效期的时间戳
     *      nobleName:"",    //贵族名称
     *      nobleLevel:1,    //贵族等级(6:大帝,5:君王,4:公爵)
     *      nobleNick:"",    //用户昵称
     *      channelInfo : {
     *         tid : 123, //顶级频道
     *         sid : 123, //子频道
     *         pid : 123, //主播id
     *         presenterNick : "", //主播昵称
     *         isGuard : false,    //是否对应主播的守护
     *         guardLevel : 1,     //守护等级
     *         isFans : true,      //是否对应主播的粉丝
     *         fansLevel : 1,      //粉丝等级
     *         fansName  : "xx"    //粉丝名称
     *      }
     *   }
     * }
     */
    "getCurrentUserInfo": function getCurrentUserInfo(params) {
      JSBridge.invoke("getCurrentUserInfo", {}, params);
    },

    /**
     * 获取当前用户的主播信息
     * @function 
     * @memberof HUYAUser
     * @param {JSBridgeReqParam} params 
     * @example
     * HUYASdk.getMyPresenterInfo({
     *    complete : function(resp) {
     *    }
     * });
     * @example resp对象示例
     * {
     *   "certified": 1, // 1认证主播, 0非认证 
     *   "presenterName": "主播昵称", 
     *   "isPresenter" : 1, // 1主播, 0非主播 
     *   "status": "ok",
     *   "err_code": 0,
     * }
     * @notice 此方法在iOS 5.5.0以后可用， Android 5.4.1后可用
     */
    "getMyPresenterInfo": function getMyPresenterInfo(params) {
      JSBridge.invoke("getMyPresenterInfo", {}, params);
    },

    /**
     * 是否第三方登录
     * @function 
     * @memberof HUYAUser
     * @param {JSBridgeReqParam} params 
     * @example
     * HUYASdk.isThirdPartyLogin({
     *    complete : function(resp) {
     *       if (resp.isThirdPartyLogin) {
     *            //doxxxxx
     *       }
     *    }
     * });
     */
    "isThirdPartyLogin": function isThirdPartyLogin(params) {
      JSBridge.invoke("isThirdPartyLogin", {}, params);
    },

    /**
     * 是否已登录
     * @function 
     * @memberof HUYAUser
     * @param {JSBridgeReqParam} params 
     * @example
     * HUYASdk.isLogin({
     *    complete : function(resp) {
     *       if (resp.isLogin) {
     *            //doxxxxx
     *       }
     *    }
     * });
     */
    "isLogin": function isLogin(params) {
      JSBridge.invoke("isLogin", {}, params);
    },

    /**
     * 获取当前uid，未登录也有
     * HUYASdk.getUserId({
     *    complete : function(resp) {
     *       if (resp.userId) {
     *            //doxxxxx
     *       }
     *    }
     * });
     */
    "getUserId": function getUserId(params) {
      JSBridge.invoke("getUserId", {}, params);
    },

    /**
     * 第三方授权
     * @function 
     * @memberof HUYAUser
     * @param {JSBridgeReqParam} params 
     * @example
     * HUYASdk.thirdAuthorize({
     *        type   : 0,       //0 微博, 1 微信, 2 qq
     *     complete  : function(resp) {
     *       //resp.appId   //第三方的appid
     *       if (resp.thirdUser) {
     *           //第三方授权信息
     *           //resp.thirdUser.accessToken
     *           //resp.thirdUser.openId
     *           //resp.thirdUser.refreshToken
     *           //resp.thirdUser.expiration    //过期时间，单位：秒
     *       }
     *    }
     * });
     */
    "thirdAuthorize": function thirdAuthorize(params) {
      JSBridge.invoke("thirdAuthorize", {
        type: params.type
      }, params);
    },

    /**
     * 身份认证 , 仅限登录用户使用
     * @function 
     * @memberof HUYAUser
     * @param {JSBridgeReqParam} params 
     * @example
     * HUYASdk.startWBFaceVerify({
     *          sign : "xxx"
     *          mode : "xxx"
     *         nonce : "xxx"
     *       orderNo : "xxx"
     *       version : "xxx"
     *       wbAppId : "xxx"
     *         name  : "xxx"
     *        idNum  : "xxx"         
     *     complete  : function(resp) {
     *       if (resp.errCode == 0) {
     *          //resp.orderNo
     *          //resp.sign
     *          //resp.liveRate     //活体检测服务得分
     *          //resp.similarity   //人脸比对服务得分
     *     } else {
     *          //resp.errCode//是根据wb返回的错误码返回
     *          //resp.errMsg //是根据wb返回的错误信息  
     *     } 
     *
     * });
     */
    "startWBFaceVerify": function startWBFaceVerify(params) {
      JSBridge.invoke("startWBFaceVerify", {
        sign: params.sign,
        mode: params.mode,
        nonce: params.nonce,
        orderNo: params.orderNo,
        version: params.version,
        wbAppId: params.wbAppId,
        name: params.name,
        idNum: params.idNum
      }, params);
    },

    /**
     * 身份认证 , 登录、非登录用户都可以使用，这个比上面的多了一个参数userId
     * @function 
     * @memberof HUYAUser
     * @param {JSBridgeReqParam} params 
     * @example
     * HUYASdk.startWBFaceVerifyV2({
     *          sign : "xxx"
     *          mode : "xxx"
     *         nonce : "xxx"
     *       orderNo : "xxx"
     *       version : "xxx"
     *       wbAppId : "xxx"
     *         name  : "xxx"
     *        idNum  : "xxx"      
     *        userId : "xxx"   
     *     complete  : function(resp) {
     *       if (resp.errCode == 0) {
     *          //resp.orderNo
     *          //resp.sign
     *          //resp.liveRate     //活体检测服务得分
     *          //resp.similarity   //人脸比对服务得分
     *     } else {
     *          //resp.errCode//是根据wb返回的错误码返回
     *          //resp.errMsg //是根据wb返回的错误信息  
     *     } 
     *
     * });
     */
    "startWBFaceVerifyV2": function startWBFaceVerifyV2(params) {
      JSBridge.invoke("startWBFaceVerifyV2", {
        sign: params.sign,
        mode: params.mode,
        nonce: params.nonce,
        orderNo: params.orderNo,
        version: params.version,
        wbAppId: params.wbAppId,
        name: params.name,
        idNum: params.idNum,
        userId: params.userId
      }, params);
    },

    /**
     * 登出
     */
    "logout": function logout(params) {
      JSBridge.invoke("logout", {}, params);
    }
  };
  HUYASdk.exportApi(HUYAUser);
  /**
   * @namespace EVENT_ID 
   * @property {string}  LOGIN_SUCCESS    - 登录成功回调
   * @property {string}  LOGIN_FAILED     - 登录失败回调
   * @property {string}  KICK_OFF         - 被踢出回调
   */

  HUYASdk.exportEventID({
    LOGIN_SUCCESS: "loginSuccess",
    LOGIN_FAILED: "loginFailed",
    KICK_OFF: "kickOff"
  });
})(HUYASdk$1);

/**
 * @file 青少年模式专用
 * @author panzhiyong <panzhiyong@huya.com>
 */

(function (HUYASdk) {
  var JSBridge = HUYASdk.JSBridge;
  var HUYAYouth = {
    /**
     * 设置密码
     * @function 
     * @memberof HUYAYouth
     * @param {JSBridgeReqParam} params 
     * @example
     * HUYASdk.setYouthPassword({
     *   password: '密码',
     *   complete : function(resp) {
     *    }      
     * });
     */
    setYouthPassword: function setYouthPassword(params) {
      JSBridge.invoke("setYouthPassword", {
        "password": params.password.toString()
      }, params);
    },

    /**
     * 修改密码
     * @function 
     * @memberof HUYAYouth
     * @param {JSBridgeReqParam} params 
     * @example
     * HUYASdk.verifyYouthPassword({
     *   password: '密码',
     *   complete : function(resp) {
     *    }      
     * });
     */
    verifyYouthPassword: function verifyYouthPassword(params) {
      JSBridge.invoke("verifyYouthPassword", {
        "password": params.password.toString()
      }, params);
    },

    /**
     * 验证成功
     * @function 
     * @memberof HUYAYouth
     * @param {JSBridgeReqParam} params 
     * @example
     * HUYASdk.verifyYouthSuccess({
     *   type: "1",
     *   complete : function(resp) {
     *    }      
     * });
     */
    verifyYouthSuccess: function verifyYouthSuccess(params) {
      JSBridge.invoke("verifyYouthSuccess", {
        "type": params.type.toString()
      }, params);
    },

    /**
     * 退出青少年模式
     * @function 
     * @memberof HUYAYouth
     * @param {JSBridgeReqParam} params 
     * @example
     * HUYASdk.exitYouth({
     *   password: '密码',
     *   complete : function(resp) {
     *    }      
     * });
     */
    exitYouth: function exitYouth(params) {
      JSBridge.invoke("exitYouth", {
        "password": params.password.toString()
      }, params);
    }
  };
  HUYASdk.exportApi(HUYAYouth);
})(HUYASdk$1);

window.HUYASdk = HUYASdk$1;

var HYLiveFilmVip = {
  getFilmVipProductList: function getFilmVipProductList() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYLiveFilmVip && nativeModules.HYLiveFilmVip.getFilmVipProductList) {
      return nativeModules.HYLiveFilmVip.getFilmVipProductList(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("getFilmVipProductList", params, params);
      });
    }
  },
  buyFilmVipProduct: function buyFilmVipProduct() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYLiveFilmVip && nativeModules.HYLiveFilmVip.buyFilmVipProduct) {
      return nativeModules.HYLiveFilmVip.buyFilmVipProduct(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("buyFilmVipProduct", params, params);
      });
    }
  }
};

var HYSuperFans = {
  openSuperFansPage: function openSuperFansPage() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYSuperFans && nativeModules.HYSuperFans.openSuperFansPage) {
      return nativeModules.HYSuperFans.openSuperFansPage(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("openSuperFansPage", params, params);
      });
    }
  },
  hideInteractionPanel: function hideInteractionPanel() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYSuperFans && nativeModules.HYSuperFans.hideInteractionPanel) {
      return nativeModules.HYSuperFans.hideInteractionPanel(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("hideInteractionPanel", params, params);
      });
    }
  }
};

var HYYouth = {
  exitYouth: function exitYouth() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (params && params['password']) {
      params['password'] = params['password'].toString();
    }

    if (nativeModules.HYYouth && nativeModules.HYYouth.exitYouth) {
      return nativeModules.HYYouth.exitYouth(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("exitYouth", params, params);
      });
    }
  },
  setYouthPassword: function setYouthPassword() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (params && params['password']) {
      params['password'] = params['password'].toString();
    }

    if (nativeModules.HYYouth && nativeModules.HYYouth.setYouthPassword) {
      return nativeModules.HYYouth.setYouthPassword(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("setYouthPassword", params, params);
      });
    }
  },
  verifyYouthPassword: function verifyYouthPassword() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (params && params['password']) {
      params['password'] = params['password'].toString();
    }

    if (nativeModules.HYYouth && nativeModules.HYYouth.verifyYouthPassword) {
      return nativeModules.HYYouth.verifyYouthPassword(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("verifyYouthPassword", params, params);
      });
    }
  },
  verifyYouthSuccess: function verifyYouthSuccess() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (params && params['type']) {
      params['type'] = params['type'].toString();
    }

    if (nativeModules.HYYouth && nativeModules.HYYouth.verifyYouthSuccess) {
      return nativeModules.HYYouth.verifyYouthSuccess(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("verifyYouthSuccess", params, params);
      });
    }
  }
};

var HYCache = {
  addCache: function addCache() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYCache && nativeModules.HYCache.addCache) {
      return nativeModules.HYCache.addCache(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("addCache", params, params);
      });
    }
  },
  clearCache: function clearCache() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYCache && nativeModules.HYCache.clearCache) {
      return nativeModules.HYCache.clearCache(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("clearCache", params, params);
      });
    }
  },
  getCache: function getCache() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYCache && nativeModules.HYCache.getCache) {
      return nativeModules.HYCache.getCache(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("getCache", params, params);
      });
    }
  },
  hasCache: function hasCache() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYCache && nativeModules.HYCache.hasCache) {
      return nativeModules.HYCache.hasCache(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("hasCache", params, params);
      });
    }
  },
  removeCache: function removeCache() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYCache && nativeModules.HYCache.removeCache) {
      return nativeModules.HYCache.removeCache(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("removeCache", params, params);
      });
    }
  }
};

var HYDownload = {
  getAppDownloadInfo: function getAppDownloadInfo() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYDownload && nativeModules.HYDownload.getAppDownloadInfo) {
      return nativeModules.HYDownload.getAppDownloadInfo(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("getAppDownloadInfo", params, params);
      });
    }
  },
  startDownload: function startDownload() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYDownload && nativeModules.HYDownload.startDownload) {
      return nativeModules.HYDownload.startDownload(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("startDownload", params, params);
      });
    }
  },
  pauseDownload: function pauseDownload() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYDownload && nativeModules.HYDownload.pauseDownload) {
      return nativeModules.HYDownload.pauseDownload(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("pauseDownload", params, params);
      });
    }
  },
  pauseAllDownload: function pauseAllDownload() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYDownload && nativeModules.HYDownload.pauseAllDownload) {
      return nativeModules.HYDownload.pauseAllDownload(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("pauseAllDownload", params, params);
      });
    }
  },
  startApp: function startApp() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYDownload && nativeModules.HYDownload.startApp) {
      return nativeModules.HYDownload.startApp(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("startApp", params, params);
      });
    }
  },
  cancelDownLoad: function cancelDownLoad() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYDownload && nativeModules.HYDownload.cancelDownLoad) {
      return nativeModules.HYDownload.cancelDownLoad(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("cancelDownLoad", params, params);
      });
    }
  },
  cancelAllDownload: function cancelAllDownload() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYDownload && nativeModules.HYDownload.cancelAllDownload) {
      return nativeModules.HYDownload.cancelAllDownload(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("cancelAllDownload", params, params);
      });
    }
  },
  intallApk: function intallApk() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYDownload && nativeModules.HYDownload.intallApk) {
      return nativeModules.HYDownload.intallApk(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("intallApk", params, params);
      });
    }
  },
  on: function on(eventId, callback) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (nativeModules.HYDownload && nativeModules.HYDownload.on) {
      nativeModules.HYDownload.on(eventId, callback, params);
    } else {
      HUYASdk.JSBridge.on(eventId, params, callback);
    }
  },
  off: function off(eventId, callback) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (nativeModules.HYDownload && nativeModules.HYDownload.off) {
      nativeModules.HYDownload.off(eventId, callback, params);
    } else {
      HUYASdk.JSBridge.off(eventId, params, callback);
    }
  },
  shareAssistFinish: function shareAssistFinish(shareAssistUrl) {
    var params = {
      shareAssistUrl
    };

    if (nativeModules.HYDownload && nativeModules.HYDownload.shareAssistFinish) {
      return nativeModules.HYDownload.shareAssistFinish(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("shareAssistFinish", params, params);
      });
    }
  }
};
var installApkEventChanged = "INSTALL_APK_EVENT_CHANGED";

var HYThirdCall = {
  joinGangup: function joinGangup() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (params) {
      if (params['openId']) {
        params['openId'] = params['openId'].toString();
      }

      if (params['token']) {
        params['token'] = params['token'].toString();
      }

      if (params['roomId']) {
        params['roomId'] = params['roomId'].toString();
      }

      if (params['accType']) {
        params['accType'] = params['accType'].toString();
      }

      params['platform'] = '5';
    }

    if (nativeModules.HYThirdCall && nativeModules.HYThirdCall.joinGangup) {
      return nativeModules.HYThirdCall.joinGangup(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("joinGangup", params, params);
      });
    }
  }
};

var HYLogin = {
  isThirdPartyLogin: function isThirdPartyLogin() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYLogin && nativeModules.HYLogin.isThirdPartyLogin) {
      return nativeModules.HYLogin.isThirdPartyLogin(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke('isThirdPartyLogin', params, params);
      });
    }
  },
  isLogin: function isLogin() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYLogin && nativeModules.HYLogin.isLogin) {
      return nativeModules.HYLogin.isLogin(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke('isLogin', params, params);
      });
    }
  },
  logout: function logout() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYLogin && nativeModules.HYLogin.logout) {
      return nativeModules.HYLogin.logout(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke('logout', params, params);
      });
    }
  },
  showLogin: function showLogin() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYLogin && nativeModules.HYLogin.showLogin) {
      return nativeModules.HYLogin.showLogin(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke('showLogin', params, params);
      });
    }
  },
  thirdAuthorize: function thirdAuthorize() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYLogin && nativeModules.HYLogin.thirdAuthorize) {
      return nativeModules.HYLogin.thirdAuthorize(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke('thirdAuthorize', params, params);
      });
    }
  },
  getCarrierPhoneNumber: function getCarrierPhoneNumber() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYLogin && nativeModules.HYLogin.getCarrierPhoneNumber) {
      return nativeModules.HYLogin.getCarrierPhoneNumber(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke('getCarrierPhoneNumber', params, params);
      });
    }
  },
  getCarrierAuthorization: function getCarrierAuthorization() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYLogin && nativeModules.HYLogin.getCarrierAuthorization) {
      return nativeModules.HYLogin.getCarrierAuthorization(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke('getCarrierAuthorization', params, params);
      });
    }
  },
  on: function on(eventId, callback) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (nativeModules.HYLogin && nativeModules.HYLogin.on) {
      nativeModules.HYLogin.on(eventId, callback, params);
    } else {
      HUYASdk.JSBridge.on(eventId, params, callback);
    }
  },
  off: function off(eventId, callback) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (nativeModules.HYLogin && nativeModules.HYLogin.off) {
      nativeModules.HYLogin.off(eventId, callback, params);
    } else {
      HUYASdk.JSBridge.off(eventId, params, callback);
    }
  }
};
var loginSuccess = 'loginSuccess';
var loginFailed = 'loginFailed';
var kickOff = 'kickOff';

var HYAuth = {
  startWBFaceVerify: function startWBFaceVerify() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYAuth && nativeModules.HYAuth.startWBFaceVerify) {
      return nativeModules.HYAuth.startWBFaceVerify(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("startWBFaceVerify", params, params);
      });
    }
  },
  startWBFaceVerifyV2: function startWBFaceVerifyV2() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYAuth && nativeModules.HYAuth.startWBFaceVerifyV2) {
      return nativeModules.HYAuth.startWBFaceVerifyV2(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("startWBFaceVerifyV2", params, params);
      });
    }
  },
  startWBFaceVerifyFaceId: function startWBFaceVerifyFaceId() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYAuth && nativeModules.HYAuth.startWBFaceVerifyFaceId) {
      return nativeModules.HYAuth.startWBFaceVerifyFaceId(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("startWBFaceVerifyFaceId", params, params);
      });
    }
  }
};

var HYUserInfo = {
  getCurrentUserInfo: function getCurrentUserInfo() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYUI && nativeModules.HYUserInfo.getCurrentUserInfo) {
      return nativeModules.HYUserInfo.getCurrentUserInfo(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("getCurrentUserInfo", params, params);
      });
    }
  },
  getMyPresenterInfo: function getMyPresenterInfo() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYUI && nativeModules.HYUserInfo.getMyPresenterInfo) {
      return nativeModules.HYUserInfo.getMyPresenterInfo(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("getMyPresenterInfo", params, params);
      });
    }
  },
  getUserId: function getUserId() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYUI && nativeModules.HYUserInfo.getUserId) {
      return nativeModules.HYUserInfo.getUserId(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("getUserId", params, params);
      });
    }
  }
};

var HYDevice = {
  getAppInfo: function getAppInfo() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYDevice && nativeModules.HYDevice.getAppInfo) {
      return nativeModules.HYDevice.getAppInfo(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("getAppInfo", params, function (resp) {
          handleResponse(func, resp, params);
        });
      });
    }
  },
  getDeviceInfo: function getDeviceInfo() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYDevice && nativeModules.HYDevice.getDeviceInfo) {
      return nativeModules.HYDevice.getDeviceInfo(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("getDeviceInfo", params, params);
      });
    }
  },
  copyToClipboard: function copyToClipboard() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYDevice && nativeModules.HYDevice.copyToClipboard) {
      return nativeModules.HYDevice.copyToClipboard(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("copyToClipboard", params, params);
      });
    }
  },
  getCurrentNetworkType: function getCurrentNetworkType() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYDevice && nativeModules.HYDevice.getCurrentNetworkType) {
      return nativeModules.HYDevice.getCurrentNetworkType(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("getCurrentNetworkType", params, params);
      });
    }
  },
  getClientLocalIP: function getClientLocalIP() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYDevice && nativeModules.HYDevice.getClientLocalIP) {
      return nativeModules.HYDevice.getClientLocalIP(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("getClientLocalIP", params, params);
      });
    }
  },
  getScreenSize: function getScreenSize() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYDevice && nativeModules.HYDevice.getScreenSize) {
      return nativeModules.HYDevice.getScreenSize(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("getScreenSize", params, params);
      });
    }
  },
  getDarkMode: function getDarkMode() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYDevice && nativeModules.HYDevice.getDarkMode) {
      return nativeModules.HYDevice.getDarkMode(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("getDarkMode", params, params);
      });
    }
  },
  getScreenRecordStatus: function getScreenRecordStatus() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYDevice && nativeModules.HYDevice.getScreenRecordStatus) {
      return nativeModules.HYDevice.getScreenRecordStatus(params);
    } else {
      var errMessage = "HYDevice.getScreenRecordStatus is not find in HYDevice:".concat(JSON.stringify(nativeModules.HYDevice));
      window.onerror(errMessage);
      return new Promise(function (_resolve, reject) {
        reject({
          errorCode: -1,
          message: errMessage
        });
      });
    }
  },
  forbidScreenRecord: function forbidScreenRecord() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYDevice && nativeModules.HYDevice.forbidScreenRecord) {
      return nativeModules.HYDevice.forbidScreenRecord(params);
    } else {
      var errMessage = "HYDevice.forbidScreenRecord is not find in HYDevice:".concat(JSON.stringify(nativeModules.HYDevice));
      window.onerror(errMessage);
      return new Promise(function (_resolve, reject) {
        reject({
          errorCode: -1,
          message: errMessage
        });
      });
    }
  },
  on: function on(eventId, callback) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (nativeModules.HYDevice && nativeModules.HYDevice.on) {
      nativeModules.HYDevice.on(eventId, callback, params);
    } else {
      HUYASdk.JSBridge.on(eventId, params, callback);
    }
  },
  off: function off(eventId, callback) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (nativeModules.HYDevice && nativeModules.HYDevice.off) {
      nativeModules.HYDevice.off(eventId, callback, params);
    } else {
      HUYASdk.JSBridge.off(eventId, params, callback);
    }
  }
};
var willResignActive = 'WILL_RESIGN_ACTIVE';
var didBecomeActive = 'DID_BECOME_ACTIVE';
var networkChanged = 'NETWORK_CHANGED';
var screenRecordChanged = 'SCREEN_RECORD_CHANGED';

var HYLivingRoomActivity = {
  isActivityWindowExpanded: function isActivityWindowExpanded() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYLivingRoomActivity && nativeModules.HYLivingRoomActivity.isActivityWindowExpanded) {
      return nativeModules.HYLivingRoomActivity.isActivityWindowExpanded(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("isActivityWindowExpanded", params, params);
      });
    }
  },
  expandActivityWindow: function expandActivityWindow() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYLivingRoomActivity && nativeModules.HYLivingRoomActivity.expandActivityWindow) {
      return nativeModules.HYLivingRoomActivity.expandActivityWindow(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("expandActivityWindow", params, params);
      });
    }
  },
  on: function on(eventId, callback) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (nativeModules.HYLivingRoomActivity && nativeModules.HYLivingRoomActivity.on) {
      nativeModules.HYLivingRoomActivity.on(eventId, callback, params);
    } else {
      HUYASdk.JSBridge.on(eventId, params, callback);
    }
  },
  off: function off(eventId, callback) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (nativeModules.HYLivingRoomActivity && nativeModules.HYLivingRoomActivity.off) {
      nativeModules.HYLivingRoomActivity.off(eventId, callback, params);
    } else {
      HUYASdk.JSBridge.off(eventId, params, callback);
    }
  }
};
var activityWindowSizeChanged = 'ACTIVITY_WINDOW_SIZE_CHANGED';

var HYFreeFlow = {
  operationCompleted: function operationCompleted() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYFreeFlow && nativeModules.HYFreeFlow.operationCompleted) {
      return nativeModules.HYFreeFlow.operationCompleted(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("operationCompleted", params, params);
      });
    }
  },
  getImsi: function getImsi() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYFreeFlow && nativeModules.HYFreeFlow.getImsi) {
      return nativeModules.HYFreeFlow.getImsi(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("getImsi", params, params);
      });
    }
  }
};

var HYLive = {
  getChannelIds: function getChannelIds() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYLive && nativeModules.HYLive.getChannelIds) {
      return nativeModules.HYLive.getChannelIds(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("getChannelIds", params, params);
      });
    }
  },
  currentChannelInfo: function currentChannelInfo() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYLive && nativeModules.HYLive.currentChannelInfo) {
      return nativeModules.HYLive.currentChannelInfo(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("currentChannelInfo", params, params);
      });
    }
  },
  getJumpChannelInfo: function getJumpChannelInfo() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYLive && nativeModules.HYLive.getJumpChannelInfo) {
      return nativeModules.HYLive.getJumpChannelInfo(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("getJumpChannelInfo", params, params);
      });
    }
  },
  joinChannel: function joinChannel() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYLive && nativeModules.HYLive.joinChannel) {
      return nativeModules.HYLive.joinChannel(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("joinChannel", params, params);
      });
    }
  },
  leaveChannel: function leaveChannel() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYLive && nativeModules.HYLive.leaveChannel) {
      return nativeModules.HYLive.leaveChannel(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("leaveChannel", params, params);
      });
    }
  },
  getJoinMicUserList: function getJoinMicUserList() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYLive && nativeModules.HYLive.getJoinMicUserList) {
      return nativeModules.HYLive.getJoinMicUserList(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("getJoinMicUserList", params, params);
      });
    }
  },
  isFullScreen: function isFullScreen() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYLive && nativeModules.HYLive.isFullScreen) {
      return nativeModules.HYLive.isFullScreen(params);
    } else {
      var errMessage = "HYLive.isFullScreen is not find in HYLive:".concat(JSON.stringify(nativeModules.HYLive));
      window.onerror(errMessage);
      return new Promise(function (_resolve, reject) {
        reject({
          errorCode: -1,
          message: errMessage
        });
      });
    }
  },
  on: function on(eventId, callback) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (nativeModules.HYLive && nativeModules.HYLive.on) {
      nativeModules.HYLive.on(eventId, callback, params);
    } else {
      HUYASdk.JSBridge.on(eventId, params, callback);
    }
  },
  off: function off(eventId, callback) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (nativeModules.HYLive && nativeModules.HYLive.off) {
      nativeModules.HYLive.off(eventId, callback, params);
    } else {
      HUYASdk.JSBridge.off(eventId, params, callback);
    }
  }
};
var kKWJSSdkEventIdApp = 'kKWJSSdkEventIdApp';

var HYInteraction = {
  getInteractiveComData: function getInteractiveComData() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYInteraction && nativeModules.HYInteraction.getInteractiveComData) {
      return nativeModules.HYInteraction.getInteractiveComData(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("getInteractiveComData", params, params);
      });
    }
  },
  on: function on(eventId, callback) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (nativeModules.HYInteraction && nativeModules.HYInteraction.on) {
      nativeModules.HYInteraction.on(eventId, callback, params);
    } else {
      HUYASdk.JSBridge.on(eventId, params, callback);
    }
  },
  off: function off(eventId, callback) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (nativeModules.HYInteraction && nativeModules.HYInteraction.off) {
      nativeModules.HYInteraction.off(eventId, callback, params);
    } else {
      HUYASdk.JSBridge.off(eventId, params, callback);
    }
  }
};
var viewDisappear = 'VIEW_DISAPPEAR';
var viewAppear = 'VIEW_APPEAR';

var HYAudioRecord = {
  startAudioRecord: function startAudioRecord() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYAudioRecord && nativeModules.HYAudioRecord.startAudioRecord) {
      return nativeModules.HYAudioRecord.startAudioRecord(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("startAudioRecord", params, params);
      });
    }
  },
  stopAudioRecord: function stopAudioRecord() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYAudioRecord && nativeModules.HYAudioRecord.stopAudioRecord) {
      return nativeModules.HYAudioRecord.stopAudioRecord(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("stopAudioRecord", params, params);
      });
    }
  },
  cancelAudioRecord: function cancelAudioRecord() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYAudioRecord && nativeModules.HYAudioRecord.cancelAudioRecord) {
      return nativeModules.HYAudioRecord.cancelAudioRecord(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("cancelAudioRecord", params, params);
      });
    }
  },
  on: function on(eventId, callback) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (nativeModules.HYAudioRecord && nativeModules.HYAudioRecord.on) {
      nativeModules.HYAudioRecord.on(eventId, callback, params);
    } else {
      HUYASdk.JSBridge.on(eventId, params, callback);
    }
  },
  off: function off(eventId, callback) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (nativeModules.HYAudioRecord && nativeModules.HYAudioRecord.off) {
      nativeModules.HYAudioRecord.off(eventId, callback, params);
    } else {
      HUYASdk.JSBridge.off(eventId, params, callback);
    }
  }
};
var audioRecordEnd = "AUDIO_RECORD_END";

var HYSubscribe = {
  subscribePresenter: function subscribePresenter() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYSubscribe && nativeModules.HYSubscribe.subscribePresenter) {
      return nativeModules.HYSubscribe.subscribePresenter(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("subscribePresenter", params, params);
      });
    }
  },
  unSubscribePresenter: function unSubscribePresenter() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYSubscribe && nativeModules.HYSubscribe.unSubscribePresenter) {
      return nativeModules.HYSubscribe.unSubscribePresenter(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("unSubscribePresenter", params, params);
      });
    }
  }
};

var HYGift = {
  showGiftPanel: function showGiftPanel() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYGift && nativeModules.HYGift.showGiftPanel) {
      return nativeModules.HYGift.showGiftPanel(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("showGiftPanel", params, params);
      });
    }
  },
  sendGift: function sendGift() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYGift && nativeModules.HYGift.sendGift) {
      return nativeModules.HYGift.sendGift(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("sendGift", params, params);
      });
    }
  }
};

var HYShare = {
  setShareInfo: function setShareInfo() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYShare && nativeModules.HYShare.setShareInfo) {
      return nativeModules.HYShare.setShareInfo(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("setShareInfo", params, params);
      });
    }
  },
  shareTo: function shareTo() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYShare && nativeModules.HYShare.shareTo) {
      return nativeModules.HYShare.shareTo(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("shareTo", params, params);
      });
    }
  }
};

var HYRouter = {
  showExchange: function showExchange() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYRouter && nativeModules.HYRouter.showExchange) {
      return nativeModules.HYRouter.showExchange(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("showExchange", params, params);
      });
    }
  },
  showPrivileges: function showPrivileges() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYRouter && nativeModules.HYRouter.showPrivileges) {
      return nativeModules.HYRouter.showPrivileges(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("showPrivileges", params, params);
      });
    }
  },
  showGuard: function showGuard() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYRouter && nativeModules.HYRouter.showGuard) {
      return nativeModules.HYRouter.showGuard(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("showGuard", params, params);
      });
    }
  },
  openUrl: function openUrl() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYRouter && nativeModules.HYRouter.openUrl) {
      return nativeModules.HYRouter.openUrl(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("openUrl", params, params);
      });
    }
  },
  quit: function quit() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYRouter && nativeModules.HYRouter.quit) {
      return nativeModules.HYRouter.quit(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("quit", params, params);
      });
    }
  },
  canOpenApp: function canOpenApp() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYRouter && nativeModules.HYRouter.canOpenApp) {
      return nativeModules.HYRouter.canOpenApp(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("canOpenApp", params, params);
      });
    }
  },
  goBack: function goBack() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYRouter && nativeModules.HYRouter.goBack) {
      return nativeModules.HYRouter.goBack(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("goBack", params, params);
      });
    }
  }
};

var wupSuccessCallback = {};
var wupFailureCallback = {};
var count = 0;
var HYWup = {
  sendWupRequest: function sendWupRequest() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYWup && nativeModules.HYWup.sendWupRequest && params.unitPacket instanceof ArrayBuffer) {
      params.unitPacket = HUYASdk.Utils.arrayBufferToBase64(params.unitPacket);
      return new Promise(function (resolve, reject) {
        var id = count++;
        wupSuccessCallback[id] = resolve;
        wupFailureCallback[id] = reject;
        params.userInfo = {
          __wupBridgeRequestId: id
        };
        nativeModules.HYWup.sendWupRequest(params);
      });
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("sendWupRequest", params, params);
      });
    }
  },
  registerGroup: function registerGroup() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYWup && nativeModules.HYWup.registerGroup) {
      return nativeModules.HYWup.registerGroup(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("registerGroup", params, params);
      });
    }
  },
  pingsignal: function pingsignal() {
    var params = {};

    if (nativeModules.HYWup && nativeModules.HYWup.pingsignal) {
      var biz_js_start = +new Date() * 1000;
      params['biz_js_start'] = "".concat(biz_js_start);
      return nativeModules.HYWup.pingsignal(params).then(function (res) {
        var biz_js_end = +new Date() * 1000;
        res.biz_js_end = biz_js_end;
        return res;
      }).catch(function (e) {
        console.log("pingsignal catch error", e);
      });
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("pingsignal", params, params);
      });
    }
  },
  unRegisterGroup: function unRegisterGroup() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYWup && nativeModules.HYWup.unRegisterGroup) {
      return nativeModules.HYWup.unRegisterGroup(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("unRegisterGroup", params, params);
      });
    }
  },
  on: function on(eventId, callback) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (nativeModules.HYWup && nativeModules.HYWup.on) {
      var realCallback = function realCallback(resp) {
        if (resp && resp.data) {
          resp.data = HUYASdk.Utils.base64ToArrayBuffer(resp.data);
        }

        callback(resp);
      };

      nativeModules.HYWup.on(eventId, realCallback, params);
    } else {
      HUYASdk.JSBridge.on(eventId, params, callback);
    }
  },
  off: function off(eventId, callback) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (nativeModules.HYWup && nativeModules.HYWup.off) {
      nativeModules.HYWup.off(eventId, callback, params);
    } else {
      HUYASdk.JSBridge.off(eventId, params, callback);
    }
  }
};
var transmit = 'transmit';
var transmitWup = 'transmitWup';
var wupReceivedUri = 10000;

var onWupReceivedCallback = function onWupReceivedCallback(resp) {
  if (resp && resp.subUri == wupReceivedUri) {
    var userInfo = resp.userInfo;
    var requestId = userInfo.__wupBridgeRequestId;

    if (resp.status === 'ok') {
      var success = wupSuccessCallback[requestId];

      if (success) {
        success(resp);
      }
    } else {
      var failure = wupFailureCallback[requestId];

      if (failure) {
        failure(resp);
      }
    }

    wupSuccessCallback[requestId] = null;
    wupFailureCallback[requestId] = null;
  }
};

HYWup.on(transmitWup, onWupReceivedCallback, {
  subUri: wupReceivedUri
});

var HYReport = {
  eventReport: function eventReport() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYReport && nativeModules.HYReport.eventReport) {
      return nativeModules.HYReport.eventReport(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("eventReport", params, params);
      });
    }
  },
  statisticReport: function statisticReport() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYReport && nativeModules.HYReport.statisticReport) {
      return nativeModules.HYReport.statisticReport(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("statisticReport", params, params);
      });
    }
  }
};

var HYFeedBack = {
  sendFeedBack: function sendFeedBack() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYFeedBack && nativeModules.HYFeedBack.sendFeedBack) {
      return nativeModules.HYFeedBack.sendFeedBack(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("sendFeedBack", params, params);
      });
    }
  }
};

var HYUI = {
  setSafeAreaColor: function setSafeAreaColor() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYUI && nativeModules.HYUI.setSafeAreaColor) {
      return nativeModules.HYUI.setSafeAreaColor(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("setSafeAreaColor", params, params);
      });
    }
  },
  setWebViewFrame: function setWebViewFrame() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYUI && nativeModules.HYUI.setWebViewFrame) {
      return nativeModules.HYUI.setWebViewFrame(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("setWebViewFrame", params, params);
      });
    }
  },
  setNavigationBarTranslucent: function setNavigationBarTranslucent() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYUI && nativeModules.HYUI.setNavigationBarTranslucent) {
      return nativeModules.HYUI.setNavigationBarTranslucent(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("setNavigationBarTranslucent", params, params);
      });
    }
  },
  setNavConfigs: function setNavConfigs() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYUI && nativeModules.HYUI.setNavConfigs) {
      return nativeModules.HYUI.setNavConfigs(params);
    } else {
      var errMessage = "HYUI.setNavConfigs is not find in HYUI:".concat(JSON.stringify(nativeModules.HYUI));
      window.onerror(errMessage);
      return new Promise(function (_resolve, reject) {
        reject({
          errorCode: -1,
          message: errMessage
        });
      });
    }
  }
};

var HYUdb = {
  HYUDBMSDKQUrlCommon: function HYUDBMSDKQUrlCommon() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYUdb && nativeModules.HYUdb.HYUDBMSDKQUrlCommon) {
      return nativeModules.HYUdb.HYUDBMSDKQUrlCommon(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("HYUDBMSDKQUrlCommon", params, params);
      });
    }
  },
  HYUDBMSDKCallback: function HYUDBMSDKCallback() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYUdb && nativeModules.HYUdb.HYUDBMSDKCallback) {
      return nativeModules.HYUdb.HYUDBMSDKCallback(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("HYUDBMSDKCallback", params, params);
      });
    }
  },
  HYUDBMSDKClose: function HYUDBMSDKClose() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYUdb && nativeModules.HYUdb.HYUDBMSDKClose) {
      return nativeModules.HYUdb.HYUDBMSDKClose(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("HYUDBMSDKClose", params, params);
      });
    }
  },
  HYUDBMSDKCommon: function HYUDBMSDKCommon() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYUdb && nativeModules.HYUdb.HYUDBMSDKCommon) {
      return nativeModules.HYUdb.HYUDBMSDKCommon(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("HYUDBMSDKCommon", params, params);
      });
    }
  },
  HYUDBMSDKVersion: function HYUDBMSDKVersion() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYUdb && nativeModules.HYUdb.HYUDBMSDKVersion) {
      return nativeModules.HYUdb.HYUDBMSDKVersion(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("HYUDBMSDKVersion", params, params);
      });
    }
  }
};

var HYToast = {
  showToast: function showToast() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYToast && nativeModules.HYToast.showToast) {
      return nativeModules.HYToast.showToast(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("showToast", params, params);
      });
    }
  }
};

var HYPlayer = {
  micOpen: function micOpen() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYPlayer && nativeModules.HYPlayer.micOpen) {
      return nativeModules.HYPlayer.micOpen(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("micOpen", params, params);
      });
    }
  },
  micClose: function micClose() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYPlayer && nativeModules.HYPlayer.micClose) {
      return nativeModules.HYPlayer.micClose(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("micClose", params, params);
      });
    }
  }
};

var HYPay = {
  getIAPProductListWithName: function getIAPProductListWithName() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYPay && nativeModules.HYPay.getIAPProductListWithName) {
      return nativeModules.HYPay.getIAPProductListWithName(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("getIAPProductListWithName", params, params);
      });
    }
  },
  buyIAPProductWithParams: function buyIAPProductWithParams() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYPay && nativeModules.HYPay.buyIAPProductWithParams) {
      return nativeModules.HYPay.buyIAPProductWithParams(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("buyIAPProductWithParams", params, params);
      });
    }
  }
};

var HYTeamMedal = {
  notifyUserTeamMedalInfo: function notifyUserTeamMedalInfo() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYTeamMedal && nativeModules.HYTeamMedal.notifyUserTeamMedalInfo) {
      return nativeModules.HYTeamMedal.notifyUserTeamMedalInfo(params);
    } else {
      if (window.KiwiJSBridge) {
        return new Promise(function (resolve, reject) {
          params['success'] = function (resp) {
            resolve(resp);
          };

          params['cancel'] = function (resp) {
            reject(resp);
          };

          params['fail'] = function (resp) {
            reject(resp);
          };

          HUYASdk.JSBridge.invoke("notifyUserTeamMedalInfo", params, params);
        });
      } else {
        return new Promise(function (_resolve, reject) {
          reject({
            errorCode: -1,
            message: "HYTeamMedal.notifyUserTeamMedalInfo is not find in HYTeamMedal:".concat(JSON.stringify(nativeModules.HYTeamMedal))
          });
        });
      }
    }
  }
};

var HYLiveTreasureBox = {
  handleAwardBoxPrize: function handleAwardBoxPrize() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYLiveTreasureBox && nativeModules.HYLiveTreasureBox.handleAwardBoxPrize) {
      return nativeModules.HYLiveTreasureBox.handleAwardBoxPrize(params);
    } else {
      return new Promise(function (_resolve, reject) {
        reject({
          errorCode: -1,
          message: "HYLiveTreasureBox.handleAwardBoxPrize is not find in HYLiveTreasureBox:".concat(JSON.stringify(nativeModules.HYLiveTreasureBox))
        });
      });
    }
  }
};

var HYSettingsData = {
  getStringValueForKey: function getStringValueForKey() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYSettingsData && nativeModules.HYSettingsData.getStringValueForKey) {
      return nativeModules.HYSettingsData.getStringValueForKey(params);
    } else {
      return new Promise(function (_resolve, reject) {
        reject({
          errorCode: -1,
          message: "HYSettingsData.getStringValueForKey is not find in HYSettingsData:".concat(JSON.stringify(nativeModules.HYSettingsData))
        });
      });
    }
  },
  setStringValue: function setStringValue() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYSettingsData && nativeModules.HYSettingsData.setStringValue) {
      return nativeModules.HYSettingsData.setStringValue(params);
    } else {
      return new Promise(function (_resolve, reject) {
        reject({
          errorCode: -1,
          message: "HYSettingsData.setStringValue is not find in HYSettingsData:".concat(JSON.stringify(nativeModules.HYSettingsData))
        });
      });
    }
  }
};

var HYSettingBack = {
  setCanBack: function setCanBack() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYSettingBack && nativeModules.HYSettingBack.setCanBack) {
      return nativeModules.HYSettingBack.setCanBack(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke("setCanBack", params, params);
      });
    }
  },
  on: function on(eventId, callback) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (nativeModules.HYSettingBack && nativeModules.HYSettingBack.on) {
      nativeModules.HYSettingBack.on(eventId, callback, params);
    } else {
      HUYASdk.JSBridge.on(eventId, params, callback);
    }
  },
  off: function off(eventId, callback) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (nativeModules.HYSettingBack && nativeModules.HYSettingBack.off) {
      nativeModules.HYSettingBack.off(eventId, callback, params);
    } else {
      HUYASdk.JSBridge.off(eventId, params, callback);
    }
  }
};
var TAP_BACK = 'TAP_BACK';

var HYSaveInAlbum = {
  saveImageToPhotosAlbum: function saveImageToPhotosAlbum() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYSaveInAlbum && nativeModules.HYSaveInAlbum.saveImageToPhotosAlbum) {
      return nativeModules.HYSaveInAlbum.saveImageToPhotosAlbum(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke('saveImageToPhotosAlbum', params, params);
      });
    }
  },
  saveVideoToPhotosAlbum: function saveVideoToPhotosAlbum() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYSaveInAlbum && nativeModules.HYSaveInAlbum.saveVideoToPhotosAlbum) {
      return nativeModules.HYSaveInAlbum.saveVideoToPhotosAlbum(params);
    } else {
      return new Promise(function (resolve, reject) {
        params['success'] = function (resp) {
          resolve(resp);
        };

        params['cancel'] = function (resp) {
          reject(resp);
        };

        params['fail'] = function (resp) {
          reject(resp);
        };

        HUYASdk.JSBridge.invoke('saveVideoToPhotosAlbum', params, params);
      });
    }
  }
};

function _createForOfIteratorHelper$1(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray$1(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var OldHYNativeEventCenter = /*#__PURE__*/function () {
  function OldHYNativeEventCenter() {
    var _this = this;

    classCallCheck(this, OldHYNativeEventCenter);

    this._nativeEventListeners = new Map();

    this._callback = function (params) {
      _this._dispatchEvent(params);
    };
  }

  createClass(OldHYNativeEventCenter, [{
    key: "addEventListener",
    value: function addEventListener(listener, eventName, callback) {
      if (!listener || !eventName || !callback) {
        return;
      }

      this._addEventEmitterListenerIfNeed();

      var listeners = this._nativeEventListeners.get(eventName);

      if (!listeners) {
        HUYASdk.JSBridge.invoke("addEventListener", {
          'eventName': eventName
        });
        listeners = new Map();

        this._nativeEventListeners.set(eventName, listeners);
      }

      listeners.set(listener, callback);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(listener, eventName) {
      if (!listener || !eventName) {
        return;
      }

      var listeners = this._nativeEventListeners.get(eventName);

      if (listeners) {
        listeners.delete(listener);

        if (listeners.size == 0) {
          this._nativeEventListeners.delete(eventName);

          HUYASdk.JSBridge.invoke('removeEventListener', {
            'eventName': eventName
          });
        }
      }

      this._removeEventEmitterListenerIfNeed();
    }
  }, {
    key: "clearEventListener",
    value: function clearEventListener(listener) {
      if (!listener) {
        return;
      }

      var emptyEvents = new Array();

      var _iterator = _createForOfIteratorHelper$1(this._nativeEventListeners.keys()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _eventName = _step.value;

          var listeners = this._nativeEventListeners.get(_eventName);

          if (listeners.size > 0) {
            listeners.delete(listener);

            if (listeners.size == 0) {
              emptyEvents.push(_eventName);
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      for (var index = 0; index < emptyEvents.length; index++) {
        var eventName = emptyEvents[index];

        this._nativeEventListeners.delete(eventName);

        HUYASdk.JSBridge.invoke('removeEventListener', {
          'eventName': eventName
        });
      }
    }
  }, {
    key: "clearAllListener",
    value: function clearAllListener() {
      var _this2 = this;

      this._nativeEventListeners.forEach(function (value, key) {
        _this2._nativeEventListeners.delete(key);

        HUYASdk.JSBridge.invoke('removeEventListener', {
          'eventName': key
        });
      });
    }
  }, {
    key: "postEventToNative",
    value: function postEventToNative(eventName, userInfo) {
      HUYASdk.JSBridge.invoke('postEvent', {
        'eventName': eventName,
        'userInfo': userInfo
      });
    }
  }, {
    key: "_addEventEmitterListenerIfNeed",
    value: function _addEventEmitterListenerIfNeed() {
      if (this._nativeEventListeners.size == 0) {
        HUYASdk.JSBridge.on('nativeEvent', {}, this._callback);
      }
    }
  }, {
    key: "_removeEventEmitterListenerIfNeed",
    value: function _removeEventEmitterListenerIfNeed() {
      if (this._nativeEventListeners.size == 0) {
        HUYASdk.JSBridge.off('nativeEvent', {}, this._callback);
      }
    }
  }, {
    key: "_dispatchEvent",
    value: function _dispatchEvent(reminder) {
      var name = reminder.name;
      var params = reminder.params;

      var listeners = this._nativeEventListeners.get(name);

      if (!listeners) {
        return;
      }

      var _iterator2 = _createForOfIteratorHelper$1(listeners.keys()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var key = _step2.value;
          var callback = listeners.get(key);
          callback(params);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }]);

  return OldHYNativeEventCenter;
}();

var oldHYNativeEventCenter = new OldHYNativeEventCenter();

var HYNativeEventCenter$1 = {
  addEventListener: function addEventListener(listener, eventName, callback) {
    if (nativeModules.HYNativeEventCenter && nativeModules.HYNativeEventCenter.addEventListener) {
      hyNativeEventCenter.addEventListener(listener, eventName, callback);
    } else {
      oldHYNativeEventCenter.addEventListener(listener, eventName, callback);
    }
  },
  removeEventListener: function removeEventListener(listener, eventName) {
    if (nativeModules.HYNativeEventCenter && nativeModules.HYNativeEventCenter.removeEventListener) {
      hyNativeEventCenter.removeEventListener(listener, eventName);
    } else {
      oldHYNativeEventCenter.removeEventListener(listener, eventName);
    }
  },
  clearEventListener: function clearEventListener(listener) {
    if (nativeModules.HYNativeEventCenter && nativeModules.HYNativeEventCenter.clearEventListener) {
      hyNativeEventCenter.clearEventListener(listener);
    } else {
      oldHYNativeEventCenter.clearEventListener(params);
    }
  },
  clearAllListener: function clearAllListener() {
    if (nativeModules.HYNativeEventCenter && nativeModules.HYNativeEventCenter.clearAllListener) {
      hyNativeEventCenter.clearAllListener();
    } else {
      oldHYNativeEventCenter.clearAllListener();
    }
  },
  postEventToNative: function postEventToNative(eventName, userInfo) {
    if (nativeModules.HYNativeEventCenter && nativeModules.HYNativeEventCenter.postEvent) {
      hyNativeEventCenter.postEventToNative(eventName, userInfo);
    } else {
      oldHYNativeEventCenter.postEventToNative(eventName, userInfo);
    }
  }
};

var HYAAID = {
  turnoffAAID: function turnoffAAID() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYAAID && nativeModules.HYAAID.turnoffAAID) {
      return nativeModules.HYAAID.turnoffAAID(params);
    } else {
      var errMessage = "HYAAID.turnoffAAID is not find in HYAAID:".concat(JSON.stringify(nativeModules.HYAAID)); // window.onerror(errMessage);

      return new Promise(function (_resolve, reject) {
        reject({
          errorCode: -1,
          message: errMessage
        });
      });
    }
  },
  queryAAIDStatus: function queryAAIDStatus() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYAAID && nativeModules.HYAAID.queryAAIDStatus) {
      return nativeModules.HYAAID.queryAAIDStatus(params);
    } else {
      var errMessage = "HYAAID.queryAAIDStatus is not find in HYAAID:".concat(JSON.stringify(nativeModules.HYAAID)); // window.onerror(errMessage);

      return new Promise(function (_resolve, reject) {
        reject({
          errorCode: -1,
          message: errMessage
        });
      });
    }
  }
};

var HYNestedScroll = {
  updateScrollTop: function updateScrollTop() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYNestedScroll && nativeModules.HYNestedScroll.updateScrollTop) {
      return nativeModules.HYNestedScroll.updateScrollTop(params);
    }
  }
};

var HYWebView = {
  closeWebView: function closeWebView() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYWebView && nativeModules.HYWebView.closeWebView) {
      return nativeModules.HYWebView.closeWebView(params);
    } else {
      return Promise.reject(new Error('not support'));
    }
  },
  getContext: function getContext() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYWebView && nativeModules.HYWebView.getContext) {
      return nativeModules.HYWebView.getContext(params);
    } else {
      var errMessage = "HYWebView.getContext is not find in HYWebView:".concat(JSON.stringify(nativeModules.HYWebView));
      window.onerror(errMessage);
      return new Promise(function (_resolve, reject) {
        reject({
          errorCode: -1,
          message: errMessage
        });
      });
    }
  },
  setContext: function setContext() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYWebView && nativeModules.HYWebView.setContext) {
      return nativeModules.HYWebView.setContext(params);
    } else {
      var errMessage = "HYWebView.setContext is not find in HYWebView:".concat(JSON.stringify(nativeModules.HYWebView));
      window.onerror(errMessage);
      return new Promise(function (_resolve, reject) {
        reject({
          errorCode: -1,
          message: errMessage
        });
      });
    }
  }
};

var HYWebPersonal = {
  scrollTop: function scrollTop() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYWebPersonal && nativeModules.HYWebPersonal.scrollTop) {
      return nativeModules.HYWebPersonal.scrollTop(params);
    }
  }
};

var HYPanel = {
  setPopupLayout: function setPopupLayout() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYPanel && nativeModules.HYPanel.setPopupLayout) {
      return nativeModules.HYPanel.setPopupLayout(params);
    } else {
      var errMessage = "HYPanel.setPopupLayout is not find in HYPanel:".concat(JSON.stringify(nativeModules.HYPanel));
      window.onerror(errMessage);
      return new Promise(function (_resolve, reject) {
        reject({
          errorCode: -1,
          message: errMessage
        });
      });
    }
  },
  dismissPopup: function dismissPopup() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYPanel && nativeModules.HYPanel.dismissPopup) {
      return nativeModules.HYPanel.dismissPopup(params);
    } else {
      var errMessage = "HYPanel.dismissPopup is not find in HYPanel:".concat(JSON.stringify(nativeModules.HYPanel));
      window.onerror(errMessage);
      return new Promise(function (_resolve, reject) {
        reject({
          errorCode: -1,
          message: errMessage
        });
      });
    }
  }
};

var HYWebShortcut = {
  createShortcut: function createShortcut() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYWebShortcut && nativeModules.HYWebShortcut.createShortcut) {
      return nativeModules.HYWebShortcut.createShortcut(params);
    } else {
      var errMessage = "HYWebShortcut.createShortcut is not find in HYWebShortcut:".concat(JSON.stringify(nativeModules.HYWebShortcut));
      window.onerror(errMessage);
      return new Promise(function (_resolve, reject) {
        reject({
          errorCode: -1,
          message: errMessage
        });
      });
    }
  },
  goAppDetailSettingsPage: function goAppDetailSettingsPage() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYWebShortcut && nativeModules.HYWebShortcut.goAppDetailSettingsPage) {
      return nativeModules.HYWebShortcut.goAppDetailSettingsPage(params);
    } else {
      var errMessage = "HYWebShortcut.goAppDetailSettingsPage is not find in HYWebShortcut:".concat(JSON.stringify(nativeModules.HYWebShortcut));
      window.onerror(errMessage);
      return new Promise(function (_resolve, reject) {
        reject({
          errorCode: -1,
          message: errMessage
        });
      });
    }
  },
  isShortCutExist: function isShortCutExist() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYWebShortcut && nativeModules.HYWebShortcut.isShortCutExist) {
      return nativeModules.HYWebShortcut.isShortCutExist(params);
    } else {
      var errMessage = "HYWebShortcut.isShortCutExist is not find in HYWebShortcut:".concat(JSON.stringify(nativeModules.HYWebShortcut));
      window.onerror(errMessage);
      return new Promise(function (_resolve, reject) {
        reject({
          errorCode: -1,
          message: errMessage
        });
      });
    }
  },
  hasCreateShortcutPermission: function hasCreateShortcutPermission() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYWebShortcut && nativeModules.HYWebShortcut.hasCreateShortcutPermission) {
      return nativeModules.HYWebShortcut.hasCreateShortcutPermission(params);
    } else {
      var errMessage = "HYWebShortcut.hasCreateShortcutPermission is not find in HYWebShortcut:".concat(JSON.stringify(nativeModules.HYWebShortcut));
      window.onerror(errMessage);
      return new Promise(function (_resolve, reject) {
        reject({
          errorCode: -1,
          message: errMessage
        });
      });
    }
  }
};

var HYDynamicConfig = {
  isVersionInReview: function isVersionInReview() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYDynamicConfig && nativeModules.HYDynamicConfig.isVersionInReview) {
      return nativeModules.HYDynamicConfig.isVersionInReview(params);
    } else {
      var errMessage = "HYDynamicConfig.isVersionInReview is not find in HYDynamicConfig:".concat(JSON.stringify(nativeModules.HYDynamicConfig));
      window.onerror(errMessage);
      return new Promise(function (_resolve, reject) {
        reject({
          errorCode: -1,
          message: errMessage
        });
      });
    }
  },
  getDynamicConfig: function getDynamicConfig() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYDynamicConfig && nativeModules.HYDynamicConfig.getDynamicConfig) {
      return nativeModules.HYDynamicConfig.getDynamicConfig(params);
    } else {
      var errMessage = "HYDynamicConfig.getDynamicConfig is not find in HYDynamicConfig:".concat(JSON.stringify(nativeModules.HYDynamicConfig));
      window.onerror(errMessage);
      return new Promise(function (_resolve, reject) {
        reject({
          errorCode: -1,
          message: errMessage
        });
      });
    }
  }
};

var HYCommodity = {
  sendCommodityInfo: function sendCommodityInfo() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYCommodity && nativeModules.HYCommodity.sendCommodityInfo) {
      return nativeModules.HYCommodity.sendCommodityInfo(params);
    } else {
      var errMessage = "HYCommodity.sendCommodityInfo is not find in HYCommodity:".concat(JSON.stringify(nativeModules.HYCommodity));
      window.onerror(errMessage);
      return new Promise(function (_resolve, reject) {
        reject({
          errorCode: -1,
          message: errMessage
        });
      });
    }
  },
  dismissView: function dismissView() {
    if (nativeModules.HYCommodity && nativeModules.HYCommodity.dismissView) {
      return nativeModules.HYCommodity.dismissView();
    } else {
      var errMessage = "HYCommodity.dismissView is not find in HYCommodity:".concat(JSON.stringify(nativeModules.HYCommodity));
      window.onerror(errMessage);
      return new Promise(function (_resolve, reject) {
        reject({
          errorCode: -1,
          message: errMessage
        });
      });
    }
  }
};

var HYAdReport = {
  landingClick: function landingClick() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYAdReport && nativeModules.HYAdReport.landingClick) {
      return nativeModules.HYAdReport.landingClick(params);
    } else {
      var errMessage = "HYAdReport.landingClick is not find in HYAdReport:".concat(JSON.stringify(nativeModules.HYAdReport));
      window.onerror(errMessage);
      return new Promise(function (_resolve, reject) {
        reject({
          errorCode: -1,
          message: errMessage
        });
      });
    }
  },
  landingExposure: function landingExposure() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (nativeModules.HYAdReport && nativeModules.HYAdReport.landingExposure) {
      return nativeModules.HYAdReport.landingExposure(params);
    } else {
      var errMessage = "HYAdReport.landingExposure is not find in HYAdReport:".concat(JSON.stringify(nativeModules.HYAdReport));
      window.onerror(errMessage);
      return new Promise(function (_resolve, reject) {
        reject({
          errorCode: -1,
          message: errMessage
        });
      });
    }
  }
};

export { Browser, HUYASdk$1 as HUYASdk, HYAAID, HYAdReport, HYAudioRecord, HYAuth, HYCache, HYCommodity, hyDataCenter as HYDataCenter, HYDevice, HYDownload, HYDynamicConfig, HYFeedBack, HYFreeFlow, HYGift, HYInteraction, HYLive, HYLiveFilmVip, HYLiveTreasureBox, HYLivingRoomActivity, HYLog, HYLogin, HYNativeEventCenter$1 as HYNativeEventCenter, HYNestedScroll, HYPanel, HYPay, HYPlayer, HYReport, HYRouter, HYSaveInAlbum, HYSettingBack, HYSettingsData, HYShare, HYSubscribe, HYSuperFans, HYTeamMedal, HYThirdCall, HYToast, HYUI, HYUdb, HYUserInfo, HYWebPersonal, HYWebShortcut, HYWebView, HYWup, HYYouth, nativeModules as NativeModules, TAP_BACK, Utils, activityWindowSizeChanged, audioRecordEnd, didBecomeActive, installApkEventChanged, kKWJSSdkEventIdApp, kickOff, loginFailed, loginSuccess, networkChanged, screenRecordChanged, transmit, transmitWup, viewAppear, viewDisappear, willResignActive };
